import * as THREE from 'three';
import { normalizeSurfaceFinishPolicy } from './graniteSurfaceFinish.utils';

export const calcModeOptions = [
    { value: 'fixed', label: 'Фиксированная цена', field: 'workPrice', suffix: '₽' },
    { value: 'linearMeter', label: 'Цена за метр', field: 'workPricePerMeter', suffix: '₽/м' },
    { value: 'squareMeter', label: 'Цена за м²', field: 'workPricePerSquareMeter', suffix: '₽/м²' },
    { value: 'cubicMeter', label: 'Цена за м³', field: 'workPricePerCubicMeter', suffix: '₽/м³' },
];


export const workTypeOptions = [
    { value: 'milling', label: 'Фрезеровка' },
    { value: 'polishing', label: 'Полировка' },
    { value: 'engraving', label: 'Гравировка' },
    { value: 'installation', label: 'Монтаж' },
    { value: 'custom', label: 'Другая работа' },
];

export const millingFormulaOptions = [
    { value: 'areaThicknessForward', label: 'По площади + надбавка за толщину' },
];

export const productPricingModeOptions = [
    { value: 'volumeForward', label: 'Старая формула по объёму' },
    { value: 'blankPlusMilling', label: 'Заготовка + фрезеровка + глобальная политика' },
    { value: 'manual', label: 'Ручная итоговая цена' },
];

export const blankSizingModeOptions = [
    { value: 'standard', label: 'Стандартная: Ш/В до 50 мм, толщина до 10 мм' },
    { value: 'exact', label: 'Точный размер без округления' },
    { value: 'manual', label: 'Размер заготовки вручную' },
];

export const blankPolishingOptions = [
    { value: 'one-side', label: '1 сторона' },
    { value: 'two-side', label: '2 стороны' },
    { value: 'five-side', label: '5 сторон' },
    { value: 'full-perimeter', label: 'Круговая полировка' },
];

export const materialSelectionModeOptions = [
    { value: 'granite', label: 'Гранит — один выбор породы' },
    { value: 'standard', label: 'Стандарт — цвет/текстура материалов' },
];

const GRANITE_CATEGORY_NAME = 'памятники ритуальные';

const normalizeMaterialSelectionCategoryName = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/\s+/g, ' ');

export const normalizeMaterialSelectionMode = (value, categoryName = '') => {
    const normalized = String(value || '').trim().toLowerCase();

    if (normalized === 'granite' || normalized === 'standard') {
        return normalized;
    }

    return normalizeMaterialSelectionCategoryName(categoryName) === GRANITE_CATEGORY_NAME
        ? 'granite'
        : 'standard';
};

export const millingRoundOptions = [
    { value: 1, label: 'Без округления' },
    { value: 10, label: 'До 10 ₽' },
    { value: 50, label: 'До 50 ₽' },
    { value: 100, label: 'До 100 ₽' },
    { value: 500, label: 'До 500 ₽' },
    { value: 1000, label: 'До 1000 ₽' },
];

export const tagPresets = [
    { label: 'Крест', values: ['крест', 'крестик', 'с крестом', 'с крестиком', 'памятник с крестом', 'памятник с крестиком'] },
    { label: 'Роза', values: ['роза', 'розы', 'с розой', 'с розами', 'розочка', 'памятник с розой', 'памятник с розами'] },
    { label: 'Свеча', values: ['свеча', 'свечка', 'со свечой', 'свечи', 'памятник со свечой', 'памятник со свечами'] },
    { label: 'Ваза', values: ['ваза', 'вазочка', 'с вазой', 'с вазами', 'памятник с вазой', 'памятник с вазами'] },
    { label: 'Ангел', values: ['ангел', 'ангелочек', 'с ангелом', 'памятник с ангелом', 'ангел на памятнике'] },
    { label: 'Сердце', values: ['сердце', 'сердечко', 'с сердцем', 'памятник с сердцем', 'памятник с сердечком'] },
    { label: 'Дерево', values: ['дерево', 'деревья', 'с деревом', 'с деревьями', 'памятник с деревом', 'памятник с деревьями'] },
    { label: 'Листья', values: ['листья', 'лист', 'листики', 'с листьями', 'памятник с листьями', 'резные листья'] },
    { label: 'Фигурный', values: ['фигурный', 'фигурная форма', 'резной', 'резная форма', 'нестандартная форма', 'памятник фигурный'] },
    { label: 'Волна', values: ['волна', 'волнистый', 'форма волна', 'памятник волна', 'памятник с волной'] },
    { label: 'Арка', values: ['арка', 'арочный', 'форма арка', 'памятник арка', 'памятник арочный'] },
    { label: 'Книга', values: ['книга', 'раскрытая книга', 'памятник книга', 'памятник в виде книги'] },
    { label: 'Плечики', values: ['плечики', 'с плечиками', 'форма с плечиками', 'памятник с плечиками'] },

    { label: 'Военный', values: ['военный', 'воин', 'солдат', 'офицер', 'памятник военному', 'памятник воину', 'памятник солдату', 'памятник офицеру', 'военный памятник', 'мемориал военному'] },
    { label: 'СВО', values: ['сво', 'участник сво', 'памятник сво', 'памятник участнику сво', 'памятник погибшему сво', 'памятник герою сво', 'мемориал сво', 'специальная военная операция', 'участник специальной военной операции'] },
    { label: 'Герой', values: ['герой', 'герою', 'памятник герою', 'памятник герою россии', 'памятник погибшему герою', 'геройски погиб', 'воин герой', 'память герою', 'мемориал герою'] },
    { label: 'Ветеран', values: ['ветеран', 'ветерану', 'ветеран боевых действий', 'участник боевых действий', 'памятник ветерану', 'памятник ветерану боевых действий', 'мемориал ветерану'] },
    { label: 'Флаг', values: ['флаг', 'с флагом', 'российский флаг', 'памятник с флагом', 'флаг на памятнике', 'триколор', 'памятник с триколором'] },
    { label: 'Звезда', values: ['звезда', 'военная звезда', 'красная звезда', 'с звездой', 'памятник со звездой', 'звезда на памятнике', 'пятиконечная звезда'] },
    { label: 'Орден', values: ['орден', 'медаль', 'награда', 'военная награда', 'боевые награды', 'памятник с орденом', 'памятник с медалью', 'орден на памятнике'] },
    { label: 'Берет', values: ['берет', 'военный берет', 'десантный берет', 'голубой берет', 'памятник с беретом', 'берет на памятнике', 'вдв', 'памятник вдв'] },
    { label: 'Автомат', values: ['автомат', 'оружие', 'военное оружие', 'памятник с автоматом', 'автомат на памятнике', 'каска', 'шлем', 'памятник с каской', 'памятник со шлемом'] },
    { label: 'Вечная память', values: ['вечная память', 'помним', 'помним скорбим', 'помним любим скорбим', 'никто не забыт', 'память воина', 'память солдата', 'светлая память'] },
];

export const getId = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;

    return value._id || value.id || '';
};

export const getProductCategoryValue = (product) => {
    return String(
        product?.categorySlug ||
        product?.categoryName ||
        getId(product?.category) ||
        product?.category ||
        'without-category'
    );
};

export const getCategoryTitle = (category) => {
    return (
        category?.label ||
        category?.name ||
        category?.title ||
        category?.categoryName ||
        'Категория'
    );
};

export const getCategoryValue = (category) => {
    return String(
        category?.value ||
        category?.slug ||
        category?._id ||
        category?.id ||
        category?.categorySlug ||
        category?.categoryName ||
        ''
    );
};

export const getProductName = (product) => {
    return product?.fullName || product?.name || product?.article || 'Товар';
};

export const fmtMoney = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number) || number <= 0) {
        return 'Цена не указана';
    }

    return `${number.toLocaleString('ru-RU')} ₽`;
};

export const DEFAULT_STONE_DENSITY_KG_M3 = 3070;

export const slugifyBlankMaterialKey = (value) => {
    const normalized = String(value || '')
        .trim()
        .toLowerCase()
        .replace(/ё/g, 'е')
        .replace(/[^a-zа-я0-9]+/giu, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80);

    // Старые сохранённые товары автоматически открываются уже как «Винга».
    return normalized === 'kapustinsky' ? 'vinga' : normalized;
};

export const inferBlankMaterialKey = (product = {}, catalogs = []) => {
    const explicit = slugifyBlankMaterialKey(
        product?.productPricing?.blankMaterialKey
        || product?.productPricing?.materialKey
    );

    if (explicit) return explicit;

    const haystack = [
        product?.nameMaterial,
        product?.productionMaterialName,
        product?.productionMaterialType,
        product?.productPricing?.materialDensityLabel,
    ].filter(Boolean).join(' ').toLowerCase();

    const match = (Array.isArray(catalogs) ? catalogs : []).find((catalog) => {
        const candidates = [catalog?.key, catalog?.name, ...(catalog?.aliases || [])]
            .map((item) => String(item || '').trim().toLowerCase())
            .filter(Boolean);

        return candidates.some((candidate) => haystack.includes(candidate));
    });

    return match?.key || 'gabbro-diabase';
};

export const getBlankMaterialCatalog = (catalogs = [], key = '') => {
    const normalizedKey = slugifyBlankMaterialKey(key);

    return (Array.isArray(catalogs) ? catalogs : []).find((catalog) => (
        slugifyBlankMaterialKey(catalog?.key) === normalizedKey
    )) || null;
};

export const fmtWeightKg = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number) || number <= 0) {
        return 'Вес не указан';
    }

    const rounded = number >= 100
        ? Math.round(number)
        : Math.round(number * 10) / 10;

    return `${rounded.toLocaleString('ru-RU')} кг`;
};

export const normalizeTags = (value) => {
    if (!value) return [];

    return Array.from(
        new Set(
            String(value)
                .split(/[,\n;]/)
                .map((item) => item.trim().replace(/^#+/, '').toLowerCase())
                .filter(Boolean)
        )
    );
};

export const tagsToString = (tags) => {
    return Array.isArray(tags) ? tags.join(', ') : '';
};

export const mergeTags = (currentTagsValue, nextTags) => {
    const current = normalizeTags(currentTagsValue);
    const incoming = Array.isArray(nextTags) ? nextTags : [];

    return Array.from(
        new Set(
            [...current, ...incoming]
                .map((item) => String(item || '').trim().replace(/^#+/, '').toLowerCase())
                .filter(Boolean)
        )
    ).join(', ');
};

export const toNumber = (value) => {
    const prepared = String(value ?? '').replace(',', '.').trim();
    const number = Number(prepared);

    return Number.isFinite(number) ? Math.max(0, number) : 0;
};


export const normalizeBlankSizingMode = (value) => (
    ['standard', 'exact', 'manual'].includes(String(value || '').trim())
        ? String(value).trim()
        : 'standard'
);

const ceilDimensionStep = (value, step, minimum = 0) => {
    const safeValue = Math.max(minimum, toNumber(value));
    const safeStep = Math.max(1, toNumber(step) || 1);

    return Math.ceil(safeValue / safeStep) * safeStep;
};

export const resolveBlankDimensions = (dimensions = {}, pricing = {}, policy = {}) => {
    const source = normalizeMillingDimensions(dimensions, {
        height: 1000,
        width: 500,
        thickness: 80,
    });
    const mode = normalizeBlankSizingMode(pricing?.blankSizingMode);
    const widthStepMm = Math.max(1, toNumber(
        policy?.blankWidthStepMm ?? pricing?.blankWidthStepMm ?? 50
    ) || 50);
    const heightStepMm = Math.max(1, toNumber(
        policy?.blankHeightStepMm ?? pricing?.blankHeightStepMm ?? 50
    ) || 50);
    const thicknessStepMm = Math.max(1, toNumber(
        policy?.blankThicknessStepMm ?? pricing?.blankThicknessStepMm ?? 10
    ) || 10);
    const minimumThicknessMm = Math.max(1, toNumber(
        policy?.blankMinimumThicknessMm ?? pricing?.blankMinimumThicknessMm ?? 30
    ) || 30);
    const manual = normalizeMillingDimensions(pricing?.manualBlankDimensions, source);

    let resolved = source;

    if (mode === 'manual') {
        resolved = {
            height: toNumber(manual.height) || source.height,
            width: toNumber(manual.width) || source.width,
            thickness: toNumber(manual.thickness) || source.thickness,
        };
    } else if (mode === 'standard') {
        resolved = {
            height: ceilDimensionStep(source.height, heightStepMm),
            width: ceilDimensionStep(source.width, widthStepMm),
            thickness: ceilDimensionStep(source.thickness, thicknessStepMm, minimumThicknessMm),
        };
    }

    const result = {
        height: Math.round(toNumber(resolved.height)),
        width: Math.round(toNumber(resolved.width)),
        thickness: Math.round(toNumber(resolved.thickness)),
        unit: 'mm',
    };

    return {
        ...result,
        mode,
        widthStepMm,
        heightStepMm,
        thicknessStepMm,
        minimumThicknessMm,
        changed: !['height', 'width', 'thickness'].every((key) => (
            Math.round(toNumber(source[key])) === Math.round(toNumber(result[key]))
        )),
        productDimensions: {
            height: Math.round(toNumber(source.height)),
            width: Math.round(toNumber(source.width)),
            thickness: Math.round(toNumber(source.thickness)),
            unit: 'mm',
        },
    };
};

export const getWidthToHeightRatio = (dimensions) => {
    const height = toNumber(dimensions?.height);
    const width = toNumber(dimensions?.width);

    if (height <= 0 || width <= 0) return null;

    return width / height;
};

export const createProportionalDimensionsPatch = (
    dimensions,
    key,
    value,
    enabled,
    lockedWidthToHeightRatio
) => {
    const patch = { [key]: value };

    if (!enabled || !['height', 'width'].includes(key)) {
        return patch;
    }

    const nextValue = Number(value);
    const fallbackRatio = getWidthToHeightRatio(dimensions);
    const lockedRatio = Number(lockedWidthToHeightRatio);
    const widthToHeightRatio = Number.isFinite(lockedRatio) && lockedRatio > 0
        ? lockedRatio
        : fallbackRatio;

    if (!Number.isFinite(nextValue) || nextValue <= 0 || !widthToHeightRatio) {
        return patch;
    }

    if (key === 'height') {
        patch.width = Math.max(1, Math.round(nextValue * widthToHeightRatio));
    } else {
        patch.height = Math.max(1, Math.round(nextValue / widthToHeightRatio));
    }

    return patch;
};

// В редакторе числовой input должен уметь временно быть пустым.
// Иначе при удалении последней цифры пустая строка превращается в 0,
// а правило размера может быть отфильтровано до ввода нового значения.
const normalizeEditableNumber = (value) => {
    if (value === '' || value === null || value === undefined) return '';

    const prepared = String(value).replace(',', '.').trim();

    if (!prepared) return '';

    const number = Number(prepared);

    return Number.isFinite(number) ? Math.max(0, number) : '';
};

const toFiniteNumber = (value) => {
    const number = Number(String(value ?? '').replace(',', '.'));

    return Number.isFinite(number) ? number : 0;
};

const normalizeDimensionToMeters = (value) => {
    const number = toFiniteNumber(value);

    if (!number || number <= 0) return 0;

    if (number > 20) {
        return number / 1000;
    }

    if (number > 3) {
        return number / 100;
    }

    return number;
};

const normalizeDimensionToMm = (value) => {
    const number = toFiniteNumber(value);

    if (!number || number <= 0) return 0;

    if (number > 20) {
        return Math.round(number);
    }

    if (number > 3) {
        return Math.round(number * 10);
    }

    return Math.round(number * 1000);
};

const metersToMm = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number) || number <= 0) return 0;

    return Math.round(number * 1000);
};

const getModelDimensionValue = (value) => {
    const number = toFiniteNumber(value);

    if (!number || number <= 0) return 0;

    return number;
};

const normalizeAxisPreset = (value) => {
    if (value === 'vertical' || value === 'horizontal') return value;

    return 'auto';
};

const detectDimensionsAxisPreset = (dimensions, explicitPreset = 'auto') => {
    if (explicitPreset === 'vertical' || explicitPreset === 'horizontal') {
        return explicitPreset;
    }

    const x = Math.max(Number(dimensions?.x) || 0, 0.001);
    const y = Math.max(Number(dimensions?.y) || 0, 0.001);
    const z = Math.max(Number(dimensions?.z) || 0, 0.001);
    const max = Math.max(x, y, z);

    if (y <= max * 0.35 && z >= max * 0.65) {
        return 'horizontal';
    }

    return 'vertical';
};

export const getModelDimensions = (modelData) => {
    const src = modelData?.baseDimensions || modelData?.dimensions || null;

    if (!src) return null;

    const x = getModelDimensionValue(src.x);
    const y = getModelDimensionValue(src.y);
    const z = getModelDimensionValue(src.z);

    if (!x && !y && !z) return null;

    return {
        x,
        y,
        z,
        source: '3D-модель',
    };
};



// PRICING_MODEL_MEASUREMENT_DIMENSIONS_V19_2_6
const hasCompletePositiveMmDimensions = (dimensions = {}) => (
    toNumber(dimensions?.height) > 0
    && toNumber(dimensions?.width) > 0
    && toNumber(dimensions?.thickness) > 0
);

const normalizeModelPathForMeasurement = (value) => String(value || '')
    .trim()
    .replace(/\\/g, '/')
    .split('?')[0]
    .replace(/^\/+/, '');

export const getPricingModelMeasurementDimensions = (product) => {
    const measurement = product?.pricingModelMeasurement;
    const dimensions = measurement?.dimensions;

    if (!hasCompletePositiveMmDimensions(dimensions)) {
        return null;
    }

    const productModelPath = normalizeModelPathForMeasurement(product?.modelPath);
    const measurementModelPath = normalizeModelPathForMeasurement(measurement?.modelPath);

    if (
        productModelPath
        && measurementModelPath
        && productModelPath !== measurementModelPath
    ) {
        return null;
    }

    return {
        height: Math.round(toNumber(dimensions.height)),
        width: Math.round(toNumber(dimensions.width)),
        thickness: Math.round(toNumber(dimensions.thickness)),
        unit: 'mm',
        source: String(measurement?.source || '3D-замер'),
    };
};

const hasPricingDimensionEvidence = (pricing = {}) => {
    const rules = Array.isArray(pricing?.sizeRules) ? pricing.sizeRules : [];

    return Boolean(
        toNumber(pricing?.basePrice) > 0
        || toNumber(pricing?.manualPrice) > 0
        || toNumber(pricing?.calculatedPrice) > 0
        || toNumber(pricing?.subscriberPriceCalculated) > 0
        || toNumber(pricing?.publicPriceCalculated) > 0
        || rules.some((rule) => (
            rule?.isBase === true
            && hasCompletePositiveMmDimensions(rule)
            && (
                toNumber(rule?.price) > 0
                || toNumber(rule?.subscriberPrice) > 0
                || toNumber(rule?.publicPrice) > 0
            )
        ))
    );
};

const resolvePricingBaseDimensionsSource = (pricing = {}, product = null) => {
    const raw = pricing?.baseDimensions;
    const measured = getPricingModelMeasurementDimensions(product);

    if (!measured) {
        return raw;
    }

    if (!hasCompletePositiveMmDimensions(raw)) {
        return null;
    }

    /*
     * 1000×500×80 раньше создавался схемой автоматически.
     * Считаем его реальной коммерческой базой только если рядом уже есть
     * ценовые данные, подтверждающие, что оператор действительно работал
     * с этим размером.
     */
    if (
        isDefaultMillingDimensions(raw)
        && !hasPricingDimensionEvidence(pricing)
    ) {
        return null;
    }

    return raw;
};

export const getProductDimensions = (product) => {
    if (!product) return null;

    const measured = getPricingModelMeasurementDimensions(product);

    if (measured) {
        return {
            x: measured.width / 1000,
            y: measured.height / 1000,
            z: measured.thickness / 1000,
            source: measured.source || '3D-замер',
        };
    }

    const x = normalizeDimensionToMeters(product.width || product.x || product.sizeX);
    const y = normalizeDimensionToMeters(product.height || product.y || product.sizeY);
    const z = normalizeDimensionToMeters(
        product.length ||
        product.depth ||
        product.thickness ||
        product.z ||
        product.sizeZ
    );

    if (!x && !y && !z) return null;

    return {
        x,
        y,
        z,
        source: 'карточка товара',
    };
};

export const getPreviewDimensions = (product, modelData) => {
    return getModelDimensions(modelData) || getProductDimensions(product) || null;
};

export const isValidDimensions = (dimensions) => {
    if (!dimensions) return false;

    return (
        Number(dimensions.x || 0) > 0 ||
        Number(dimensions.y || 0) > 0 ||
        Number(dimensions.z || 0) > 0
    );
};

export const formatMmValue = (meters) => {
    const value = Number(meters);

    if (!Number.isFinite(value) || value <= 0) return '—';

    return `${Math.round(value * 1000)} мм`;
};

export const getDimensionRows = (dimensions) => {
    if (!isValidDimensions(dimensions)) {
        return [
            { key: 'x', label: 'Ширина', value: '—' },
            { key: 'y', label: 'Высота', value: '—' },
            { key: 'z', label: 'Толщина / глубина', value: '—' },
        ];
    }

    return [
        { key: 'x', label: 'Ширина', value: formatMmValue(dimensions.x) },
        { key: 'y', label: 'Высота', value: formatMmValue(dimensions.y) },
        { key: 'z', label: 'Толщина / глубина', value: formatMmValue(dimensions.z) },
    ];
};

export const isDefaultMillingDimensions = (dimensions) => {
    if (!dimensions) return true;

    const height = Math.round(toNumber(dimensions.height));
    const width = Math.round(toNumber(dimensions.width));
    const thickness = Math.round(toNumber(dimensions.thickness));

    return height === 1000 && width === 500 && thickness === 80;
};


export const getMillingDimensionsFromProduct = (product) => {
    const measured = getPricingModelMeasurementDimensions(product);

    if (measured) {
        return {
            height: measured.height,
            width: measured.width,
            thickness: measured.thickness,
            unit: 'mm',
        };
    }

    const height = normalizeDimensionToMm(product?.height || product?.z || product?.sizeZ);
    const width = normalizeDimensionToMm(product?.width || product?.x || product?.sizeX);
    const thickness = normalizeDimensionToMm(
        product?.length ||
        product?.depth ||
        product?.thickness ||
        product?.y ||
        product?.sizeY
    );

    return {
        height: height || 0,
        width: width || 0,
        thickness: thickness || 0,
        unit: 'mm',
    };
};

export const getMillingDimensionsFromPreview = (dimensions, axisPreset = 'auto') => {
    if (!isValidDimensions(dimensions)) return null;

    const preset = detectDimensionsAxisPreset(dimensions, axisPreset);

    const x = metersToMm(dimensions.x);
    const y = metersToMm(dimensions.y);
    const z = metersToMm(dimensions.z);

    if (preset === 'horizontal') {
        return {
            height: z || 1000,
            width: x || 500,
            thickness: y || 80,
            unit: 'mm',
        };
    }

    return {
        height: y || 1000,
        width: x || 500,
        thickness: z || 80,
        unit: 'mm',
    };
};

const hasOwn = (value, key) => (
    !!value && Object.prototype.hasOwnProperty.call(value, key)
);

const normalizeEditableValueWithFallback = (
    source,
    fallbackSource,
    key,
    defaultValue
) => {
    if (hasOwn(source, key)) {
        return normalizeEditableNumber(source[key]);
    }

    const fallbackValue = normalizeEditableNumber(fallbackSource?.[key]);

    return fallbackValue === '' ? defaultValue : fallbackValue;
};

const normalizeEditablePercent = (value, fallback = 0) => {
    const normalized = normalizeEditableNumber(value);

    if (normalized === '') return '';

    return Math.min(300, Math.max(0, normalized ?? fallback));
};

const normalizeMillingDimensions = (value, fallback) => {
    const source = value && typeof value === 'object' ? value : {};
    const fallbackSource = fallback && typeof fallback === 'object' ? fallback : {};

    return {
        // Явно очищенное поле оставляем пустым во время редактирования.
        // Fallback применяется только когда поля вообще нет в исходном объекте.
        height: normalizeEditableValueWithFallback(source, fallbackSource, 'height', 0),
        width: normalizeEditableValueWithFallback(source, fallbackSource, 'width', 0),
        thickness: normalizeEditableValueWithFallback(source, fallbackSource, 'thickness', 0),
        unit: 'mm',
    };
};

export const getSceneDimensionsFromMillingForm = (form, product, fallbackDimensions) => {
    const pricing = normalizeMillingPricing(form?.millingPricing, product);
    const productPricing = normalizeProductPricing(form?.productPricing, product);
    const active = productPricing.testDimensions || pricing.testDimensions || productPricing.baseDimensions || pricing.baseDimensions;
    const base = productPricing.baseDimensions || pricing.baseDimensions;

    const baseHeight = toNumber(base.height) || 1000;
    const baseWidth = toNumber(base.width) || 500;
    const baseThickness = toNumber(base.thickness) || 80;
    const height = toNumber(active.height);
    const width = toNumber(active.width);
    const thickness = toNumber(active.thickness);

    if (!height && !width && !thickness) {
        return fallbackDimensions;
    }

    return {
        // Во время очистки одного input модель не прыгает к случайным
        // 1000×500×80: для временно пустой оси используем сохранённую базу.
        x: (width || baseWidth) / 1000,
        y: (height || baseHeight) / 1000,
        z: (thickness || baseThickness) / 1000,
        scaleBase: {
            x: baseWidth / 1000,
            y: baseHeight / 1000,
            z: baseThickness / 1000,
        },
        axisPreset: pricing.axisPreset || 'auto',
        source: 'проверяемый размер',
    };
};

export const createSharedSizeKey = (dimensions = {}, fallback = '') => {
    const existing = String(fallback || dimensions?.sizeKey || '').trim();
    if (existing) return existing;

    const height = Math.round(toNumber(dimensions?.height));
    const width = Math.round(toNumber(dimensions?.width));
    const thickness = Math.round(toNumber(dimensions?.thickness));
    const suffix = Math.random().toString(16).slice(2, 8);

    return `size-${height || 0}-${width || 0}-${thickness || 0}-${Date.now()}-${suffix}`;
};

const sameSharedDimensions = (left = {}, right = {}) => (
    Math.round(toNumber(left?.height)) === Math.round(toNumber(right?.height))
    && Math.round(toNumber(left?.width)) === Math.round(toNumber(right?.width))
    && Math.round(toNumber(left?.thickness)) === Math.round(toNumber(right?.thickness))
);

export const mergeSharedProductSizeRules = (targetRules = [], sharedRules = []) => {
    const target = Array.isArray(targetRules) ? targetRules : [];
    const shared = Array.isArray(sharedRules) ? sharedRules : [];

    return shared.map((sharedRule, index) => {
        const sizeKey = createSharedSizeKey(sharedRule, sharedRule?.sizeKey);
        const match = target.find((rule) => (
            (sizeKey && String(rule?.sizeKey || '') === sizeKey)
            || sameSharedDimensions(rule, sharedRule)
        )) || {};

        return {
            ...match,
            ...sharedRule,
            sizeKey,
            isBase: sharedRule?.isBase === true,
            label: String(sharedRule?.label || '').trim()
                || `${toNumber(sharedRule?.height)}×${toNumber(sharedRule?.width)}×${toNumber(sharedRule?.thickness)}`,
        };
    });
};

export const syncWorkPricingToSharedSizes = (pricing = {}, sharedRules = [], baseDimensions = null) => {
    const normalized = normalizeMillingPricing(pricing);
    const sourceRules = Array.isArray(normalized.sizeRules) ? normalized.sizeRules : [];
    const canonicalRules = Array.isArray(sharedRules) ? sharedRules : [];

    const sizeRules = canonicalRules.map((sharedRule) => {
        const sizeKey = createSharedSizeKey(sharedRule, sharedRule?.sizeKey);
        const existing = sourceRules.find((rule) => (
            (sizeKey && String(rule?.sizeKey || '') === sizeKey)
            || sameSharedDimensions(rule, sharedRule)
        ));
        const calculated = calculateAreaThicknessRawPrice(
            {
                ...normalized,
                baseDimensions: baseDimensions || normalized.baseDimensions,
                sizeRules: [],
                enabled: true,
            },
            sharedRule,
            0
        );

        return {
            ...(existing || {}),
            sizeKey,
            isBase: sharedRule?.isBase === true,
            label: String(sharedRule?.label || '').trim(),
            height: toNumber(sharedRule?.height),
            width: toNumber(sharedRule?.width),
            thickness: toNumber(sharedRule?.thickness),
            price: toNumber(existing?.price) > 0
                ? toNumber(existing.price)
                : toNumber(calculated.price),
            enabled: sharedRule?.enabled !== false && existing?.enabled !== false,
            note: String(existing?.note || ''),
        };
    });

    return {
        ...normalized,
        baseDimensions: baseDimensions
            ? normalizeMillingDimensions(baseDimensions, normalized.baseDimensions)
            : normalized.baseDimensions,
        sizeRules,
    };
};

export const createMillingSizeRule = (baseDimensions = {}, price = 0, options = {}) => {
    const height = toNumber(baseDimensions.height) || 1000;
    const width = toNumber(baseDimensions.width) || 500;
    const thickness = toNumber(baseDimensions.thickness) || 80;

    return {
        _clientId: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
        sizeKey: createSharedSizeKey(baseDimensions, options.sizeKey),
        isBase: options.isBase === true,
        label: `${height}×${width}×${thickness}`,
        height,
        width,
        thickness,
        price: toNumber(price),
        enabled: true,
        note: '',
    };
};

export const normalizeMillingSizeRules = (value) => {
    if (!Array.isArray(value)) return [];

    return value.map((rule, index) => {
        const height = normalizeEditableNumber(rule?.height);
        const width = normalizeEditableNumber(rule?.width);
        const thickness = normalizeEditableNumber(rule?.thickness);
        const price = normalizeEditableNumber(rule?.price);

        const label = String(rule?.label || '').trim()
            || [height, width, thickness].filter((item) => item !== '').join('×')
            || `Размер ${index + 1}`;

        return {
            _clientId: rule?._clientId || rule?._id || `${Date.now()}-${index}`,
            sizeKey: createSharedSizeKey(rule, rule?.sizeKey),
            isBase: rule?.isBase === true,
            label,
            height,
            width,
            thickness,
            price,
            enabled: rule?.enabled !== false,
            note: String(rule?.note || '').trim(),
        };
    });
};

export const normalizeMillingPricing = (pricing, product, policy = {}) => {
    const source = pricing && typeof pricing === 'object' ? pricing : {};
    const baseDimensionsFromProduct = getMillingDimensionsFromProduct(product);
    const sourceBaseDimensions = resolvePricingBaseDimensionsSource(source, product);
    const baseDimensions = normalizeMillingDimensions(
        sourceBaseDimensions,
        baseDimensionsFromProduct
    );
    const testDimensions = normalizeMillingDimensions(
        source.testDimensions || source.previewDimensions,
        baseDimensions
    );
    const useGlobalThicknessPricing = source.useGlobalThicknessPricing !== false;
    const basePrice = hasOwn(source, 'basePrice')
        ? normalizeEditableNumber(source.basePrice)
        : (toNumber(product?.workPrice) || 0);

    return {
        enabled: source.enabled === true,
        mode: 'areaThicknessForward',
        basePrice,
        baseDimensions,
        testDimensions,
        axisPreset: normalizeAxisPreset(source.axisPreset),
        setupPercent: hasOwn(source, 'setupPercent')
            ? normalizeEditablePercent(source.setupPercent)
            : 0,
        complexityMultiplier: 1,
        roundTo: toNumber(source.roundTo || 100) || 100,
        useGlobalThicknessPricing,
        thicknessStepMm: Math.max(1, toNumber(
            useGlobalThicknessPricing
                ? (policy?.millingThicknessStepMm ?? source.thicknessStepMm ?? 10)
                : (source.thicknessStepMm ?? 10)
        ) || 10),
        thicknessMarkupPercent: Math.max(0, toNumber(
            useGlobalThicknessPricing
                ? (policy?.millingThicknessMarkupPercent ?? source.thicknessMarkupPercent ?? 5)
                : (source.thicknessMarkupPercent ?? 5)
        )),
        thicknessMarkupMaxPercent: Math.max(0, toNumber(
            useGlobalThicknessPricing
                ? (policy?.millingThicknessMarkupMaxPercent ?? source.thicknessMarkupMaxPercent ?? 50)
                : (source.thicknessMarkupMaxPercent ?? 50)
        )),
        manualEnabled: source.manualEnabled === true,
        manualPrice: toNumber(source.manualPrice),
        sizeRules: normalizeMillingSizeRules(source.sizeRules),
    };
};

export const normalizeMillingPricingForSave = (pricing, product) => {
    const normalized = normalizeMillingPricing(pricing, product);

    return {
        enabled: !!normalized.enabled,
        mode: normalized.mode,
        basePrice: toNumber(normalized.basePrice),
        baseDimensions: {
            height: toNumber(normalized.baseDimensions.height),
            width: toNumber(normalized.baseDimensions.width),
            thickness: toNumber(normalized.baseDimensions.thickness),
            unit: 'mm',
        },
        axisPreset: normalized.axisPreset || 'auto',
        setupPercent: 0,
        complexityMultiplier: 1,
        roundTo: toNumber(normalized.roundTo) || 100,
        useGlobalThicknessPricing: normalized.useGlobalThicknessPricing !== false,
        thicknessStepMm: Math.max(1, toNumber(normalized.thicknessStepMm) || 10),
        thicknessMarkupPercent: Math.max(0, toNumber(normalized.thicknessMarkupPercent)),
        thicknessMarkupMaxPercent: Math.max(0, toNumber(normalized.thicknessMarkupMaxPercent)),
        manualEnabled: !!normalized.manualEnabled,
        manualPrice: toNumber(normalized.manualPrice),
        sizeRules: normalized.sizeRules
            .filter((rule) => (
                toNumber(rule.height) > 0 &&
                toNumber(rule.width) > 0 &&
                toNumber(rule.thickness) > 0
            ))
            .map((rule) => {
                const calculated = calculateAreaThicknessRawPrice(
                    {
                        ...normalized,
                        sizeRules: [],
                        enabled: true,
                    },
                    rule,
                    0
                );
                const explicitPrice = toNumber(rule.price);

                return {
                    sizeKey: createSharedSizeKey(rule, rule.sizeKey),
                    isBase: rule.isBase === true,
                    label: String(rule.label || '').trim(),
                    height: toNumber(rule.height),
                    width: toNumber(rule.width),
                    thickness: toNumber(rule.thickness),
                    // Для общего размера цена работы может быть задана вручную.
                    // Если её нет — сохраняем расчёт по формуле как стартовое значение.
                    price: explicitPrice > 0 ? explicitPrice : toNumber(calculated.price),
                    enabled: rule.enabled !== false,
                    note: String(rule.note || '').trim(),
                };
            }),
    };
};

const isSameMm = (a, b) => {
    const left = Math.round(toNumber(a));
    const right = Math.round(toNumber(b));

    return left > 0 && right > 0 && left === right;
};

export const findExactMillingRule = (pricing, dimensions) => {
    const normalized = normalizeMillingPricing(pricing);
    const dims = normalizeMillingDimensions(dimensions, normalized.baseDimensions);

    return normalized.sizeRules.find((rule) => {
        if (rule.enabled === false) return false;
        if (!rule.price) return false;
        if (!isSameMm(rule.height, dims.height)) return false;
        if (!isSameMm(rule.width, dims.width)) return false;

        if (rule.thickness > 0 && dims.thickness > 0) {
            return isSameMm(rule.thickness, dims.thickness);
        }

        return true;
    }) || null;
};

const calculateAreaThicknessRawPrice = (pricing, dimensions, fallbackPrice = 0, policy = {}) => {
    const normalized = normalizeMillingPricing(pricing, null, policy);
    const dims = normalizeMillingDimensions(dimensions, normalized.baseDimensions);

    if (!normalized.enabled) {
        const fallback = toNumber(fallbackPrice);
        return {
            price: fallback,
            source: fallback ? 'old' : 'none',
            label: fallback ? 'Старая цена' : 'Новая система выключена',
            ratio: 1,
            areaRatio: 1,
            rawAreaRatio: 1,
            thicknessSteps: 0,
            thicknessMarkupTotalPercent: 0,
            rawPrice: fallback,
        };
    }

    const basePrice = toNumber(normalized.basePrice);
    if (!basePrice) {
        const fallback = toNumber(fallbackPrice);
        return {
            price: fallback,
            source: fallback ? 'old' : 'none',
            label: fallback ? 'Старая цена' : 'Нет цены базового размера',
            ratio: 1,
            areaRatio: 1,
            rawAreaRatio: 1,
            thicknessSteps: 0,
            thicknessMarkupTotalPercent: 0,
            rawPrice: fallback,
        };
    }

    const baseHeight = toNumber(normalized.baseDimensions.height) || 1000;
    const baseWidth = toNumber(normalized.baseDimensions.width) || 500;
    const baseThickness = toNumber(normalized.baseDimensions.thickness) || 80;
    const currentHeight = toNumber(dims.height) || baseHeight;
    const currentWidth = toNumber(dims.width) || baseWidth;
    const currentThickness = toNumber(dims.thickness) || baseThickness;
    const baseArea = baseHeight * baseWidth;
    const currentArea = currentHeight * currentWidth;
    const rawAreaRatio = baseArea > 0 ? currentArea / baseArea : 1;
    const areaRatio = Math.max(1, rawAreaRatio || 1);
    const thicknessStepMm = Math.max(1, toNumber(normalized.thicknessStepMm) || 10);
    const thicknessSteps = currentThickness > baseThickness
        ? Math.ceil((currentThickness - baseThickness) / thicknessStepMm)
        : 0;
    const thicknessMarkupTotalPercent = Math.min(
        Math.max(0, toNumber(normalized.thicknessMarkupMaxPercent)),
        thicknessSteps * Math.max(0, toNumber(normalized.thicknessMarkupPercent))
    );
    const thicknessMultiplier = 1 + thicknessMarkupTotalPercent / 100;
    const ratio = areaRatio * thicknessMultiplier;
    const rawPrice = basePrice * ratio;
    const roundTo = toNumber(normalized.roundTo) || 100;
    const price = Math.round(rawPrice / roundTo) * roundTo;

    return {
        price,
        source: 'formula',
        label: 'База × площадь + надбавка за толщину',
        ratio,
        areaRatio,
        rawAreaRatio,
        thicknessSteps,
        thicknessStepMm,
        thicknessMarkupPercent: normalized.thicknessMarkupPercent,
        thicknessMarkupTotalPercent,
        thicknessMultiplier,
        rawPrice,
        baseArea,
        currentArea,
        baseThickness,
        currentThickness,
    };
};

export const calcMillingPrice = (pricing, dimensions, fallbackPrice = 0, policy = {}) => {
    const exactRule = findExactMillingRule(pricing, dimensions);
    if (exactRule) {
        return {
            price: toNumber(exactRule.price),
            source: 'rule',
            label: exactRule.label || 'Точная цена фрезеровки',
            rule: exactRule,
            ratio: 1,
            areaRatio: 1,
            rawAreaRatio: 1,
            thicknessSteps: 0,
            thicknessMarkupTotalPercent: 0,
            rawPrice: toNumber(exactRule.price),
        };
    }

    return calculateAreaThicknessRawPrice(pricing, dimensions, fallbackPrice, policy);
};

export const applyMaterialMillingMarkup = (preview = {}, materialCatalog = null, policy = {}) => {
    const basePrice = Math.max(0, toNumber(preview?.price));
    const markupPercent = Math.min(500, Math.max(0, toNumber(materialCatalog?.millingMarkupPercent)));

    if (!(basePrice > 0) || !(markupPercent > 0)) {
        return {
            ...preview,
            basePriceBeforeMaterialMarkup: basePrice,
            materialMarkupPercent: 0,
            materialMarkupAmount: 0,
        };
    }

    const rawPrice = basePrice * (1 + markupPercent / 100);
    const roundTo = toNumber(policy?.roundTo) || toNumber(materialCatalog?.defaultRoundTo) || 100;
    const price = Math.max(roundTo, Math.round(rawPrice / roundTo) * roundTo);

    return {
        ...preview,
        price,
        basePriceBeforeMaterialMarkup: basePrice,
        rawPriceBeforeMaterialMarkup: toNumber(preview?.rawPrice) || basePrice,
        materialMarkupPercent: markupPercent,
        materialMarkupAmount: Math.max(0, price - basePrice),
        rawPrice,
        source: `${preview?.source || 'milling'}+material-markup`,
        label: `${preview?.label || 'Фрезеровка'} + ${markupPercent}% за материал`,
    };
};

export const formatMillingDimensions = (dimensions) => {
    if (!dimensions) return '—';

    const height = Math.round(toNumber(dimensions.height));
    const width = Math.round(toNumber(dimensions.width));
    const thickness = Math.round(toNumber(dimensions.thickness));

    return `${height || '—'}×${width || '—'}×${thickness || '—'} мм`;
};

export const calcProductSizeWeightKg = (dimensions = {}, densityKgM3 = DEFAULT_STONE_DENSITY_KG_M3) => {
    const height = toNumber(dimensions.height);
    const width = toNumber(dimensions.width);
    const thickness = toNumber(dimensions.thickness);
    const density = toNumber(densityKgM3) || DEFAULT_STONE_DENSITY_KG_M3;

    if (!height || !width || !thickness) return 0;

    const cubicMeters = (height / 1000) * (width / 1000) * (thickness / 1000);

    return Math.round(cubicMeters * density * 10) / 10;
};

const DEFAULT_PRODUCT_CUSTOMER_PROFILES = [
    { key: 'subscriber', productionMarkupPercent: 50 },
    { key: 'public', productionMarkupPercent: 100 },
];

const roundProductCustomerMoney = (value) => (
    Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100
);

const roundProductCustomerStep = (value, step) => {
    const safeStep = Number(step) > 0 ? Number(step) : 0.01;
    return roundProductCustomerMoney(Math.round(Number(value || 0) / safeStep) * safeStep);
};

/**
 * Единая финансовая цепочка для admin-превью.
 * Изделие: закупка -> доставка -> наценка производства -> сайт -> налог.
 * Работа/услуга: введённая цена уже финальная для клиента; из неё сначала
 * выделяем налог, затем долю сайта. Остаток — чистая сумма исполнителю.
 */
export const calcForwardCustomerProfile = ({
    blankPrice = 0,
    worksPrice = 0,
    productionMarkupPercent = 0,
    pricingPolicy = {},
    profile = null,
} = {}) => {
    const blankAmount = Math.max(0, toNumber(blankPrice));
    const workBase = Math.max(0, toNumber(worksPrice));
    const deliveryPercent = Number.isFinite(Number(pricingPolicy?.deliveryPercent))
        ? Number(pricingPolicy.deliveryPercent)
        : 10;
    const siteSharePercent = Number.isFinite(Number(pricingPolicy?.siteSharePercent))
        ? Number(pricingPolicy.siteSharePercent)
        : 6;
    const taxReservePercent = Number.isFinite(Number(pricingPolicy?.taxReservePercent))
        ? Number(pricingPolicy.taxReservePercent)
        : 10;
    const roundTo = Number(pricingPolicy?.roundTo) > 0
        ? Number(pricingPolicy.roundTo)
        : 0.01;

    const deliveryAmount = roundProductCustomerMoney(blankAmount * deliveryPercent / 100);
    const procurementTotal = roundProductCustomerMoney(blankAmount + deliveryAmount);
    const productionProfit = roundProductCustomerMoney(
        procurementTotal * Math.max(0, toNumber(productionMarkupPercent)) / 100
    );
    const productionTarget = roundProductCustomerMoney(procurementTotal + productionProfit);
    const productSiteShare = roundProductCustomerMoney(productionTarget * siteSharePercent / 100);
    const productBeforeTax = roundProductCustomerMoney(productionTarget + productSiteShare);
    const productTaxBeforeRounding = roundProductCustomerMoney(productBeforeTax * taxReservePercent / 100);
    const productExact = roundProductCustomerMoney(productBeforeTax + productTaxBeforeRounding);
    const productCustomer = roundProductCustomerStep(productExact, roundTo);
    const productRounding = roundProductCustomerMoney(productCustomer - productExact);
    const productTaxReserve = roundProductCustomerMoney(productTaxBeforeRounding + productRounding);

    // workBase — совместимое имя входного значения. По смыслу это уже
    // конечная клиентская цена работы, а не чистая база исполнителя.
    const workCustomer = roundProductCustomerMoney(workBase);
    const workTaxFactor = 1 + taxReservePercent / 100;
    const workBeforeTax = roundProductCustomerMoney(workCustomer / workTaxFactor);
    const workTaxReserve = roundProductCustomerMoney(workCustomer - workBeforeTax);
    const workSiteFactor = 1 + siteSharePercent / 100;
    const workPartnerNet = roundProductCustomerMoney(workBeforeTax / workSiteFactor);
    const workSiteShare = roundProductCustomerMoney(workBeforeTax - workPartnerNet);

    return {
        profile: profile || { productionMarkupPercent },
        percentages: {
            deliveryPercent,
            siteSharePercent,
            taxReservePercent,
            productionMarkupPercent: Math.max(0, toNumber(productionMarkupPercent)),
            roundTo,
        },
        product: {
            blankAmount,
            deliveryAmount,
            procurementTotal,
            productionProfit,
            productionTarget,
            productionReceived: productionTarget,
            beforeSiteShare: productionTarget,
            siteShare: productSiteShare,
            afterSiteShare: productBeforeTax,
            beforeTax: productBeforeTax,
            taxReserve: productTaxReserve,
            customerFinal: productCustomer,
        },
        milling: {
            baseAmount: workBase,
            customerInputAmount: workCustomer,
            beforeSiteShare: workPartnerNet,
            siteShare: workSiteShare,
            afterSiteShare: workBeforeTax,
            beforeTax: workBeforeTax,
            taxReserve: workTaxReserve,
            customerFinal: workCustomer,
            partnerNet: workPartnerNet,
        },
        works: {
            baseAmount: workBase,
            customerInputAmount: workCustomer,
            beforeSiteShare: workPartnerNet,
            siteShare: workSiteShare,
            afterSiteShare: workBeforeTax,
            beforeTax: workBeforeTax,
            taxReserve: workTaxReserve,
            customerFinal: workCustomer,
            partnerNet: workPartnerNet,
        },
        totals: {
            customer: roundProductCustomerMoney(productCustomer + workCustomer),
            procurement: procurementTotal,
            siteShare: roundProductCustomerMoney(productSiteShare + workSiteShare),
            taxReserve: roundProductCustomerMoney(productTaxReserve + workTaxReserve),
            productionReceived: roundProductCustomerMoney(productionTarget + workPartnerNet),
            cleanEarnings: roundProductCustomerMoney(productionProfit + workPartnerNet),
            partner: roundProductCustomerMoney(productionProfit + workPartnerNet),
        },
    };
};

/** Возвращает две конечные клиентские цены для одного размера изделия. */
export const calcProductCustomerPrices = ({
    blankPrice = 0,
    millingPrice = 0,
    additionalWorksPrice = 0,
    worksPrice = null,
    fallbackPrice = 0,
    pricingPolicy = {},
} = {}) => {
    const millingBase = Math.max(0, toNumber(millingPrice));
    const additionalBase = Math.max(0, toNumber(additionalWorksPrice));
    const allWorksBase = worksPrice === null || worksPrice === undefined
        ? millingBase + additionalBase
        : Math.max(0, toNumber(worksPrice));
    const blankAmount = Math.max(0, toNumber(blankPrice));
    const directFallback = Math.max(0, toNumber(fallbackPrice));

    if (!(blankAmount > 0) && !(allWorksBase > 0)) {
        return {
            subscriberPrice: directFallback,
            publicPrice: directFallback,
            worksPrice: allWorksBase,
            byProfile: { subscriber: directFallback, public: directFallback },
        };
    }

    const incomingProfiles = Array.isArray(pricingPolicy?.profiles) ? pricingPolicy.profiles : [];
    const breakdowns = {};
    const byProfile = {};

    DEFAULT_PRODUCT_CUSTOMER_PROFILES.forEach((fallbackProfile) => {
        const incoming = incomingProfiles.find((profile) => profile?.key === fallbackProfile.key) || {};
        const markupPercent = Number.isFinite(Number(incoming.productionMarkupPercent))
            ? Number(incoming.productionMarkupPercent)
            : fallbackProfile.productionMarkupPercent;
        const breakdown = calcForwardCustomerProfile({
            blankPrice: blankAmount,
            worksPrice: allWorksBase,
            productionMarkupPercent: markupPercent,
            pricingPolicy,
            profile: { ...fallbackProfile, ...incoming, productionMarkupPercent: markupPercent },
        });
        breakdowns[fallbackProfile.key] = breakdown;
        byProfile[fallbackProfile.key] = breakdown.totals.customer;
    });

    return {
        subscriberPrice: toNumber(byProfile.subscriber),
        publicPrice: toNumber(byProfile.public),
        worksPrice: allWorksBase,
        byProfile,
        breakdowns,
    };
};

export const createProductSizeRule = (
    baseDimensions = {},
    price = 0,
    weightKg = 0,
    weightManual = false,
    customerPrices = {}
) => {
    const height = toNumber(baseDimensions.height) || 1000;
    const width = toNumber(baseDimensions.width) || 500;
    const thickness = toNumber(baseDimensions.thickness) || 80;

    return {
        _clientId: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
        sizeKey: createSharedSizeKey(baseDimensions, baseDimensions?.sizeKey),
        isBase: baseDimensions?.isBase === true,
        label: `${height}×${width}×${thickness}`,
        height,
        width,
        thickness,
        price: toNumber(price),
        subscriberPrice: toNumber(customerPrices.subscriberPrice),
        publicPrice: toNumber(customerPrices.publicPrice),
        weightKg: toNumber(weightKg),
        weightManual: weightManual === true,
        enabled: true,
        note: '',
    };
};

export const normalizeProductSizeRules = (value, densityKgM3 = DEFAULT_STONE_DENSITY_KG_M3) => {
    if (!Array.isArray(value)) return [];

    return value.map((rule, index) => {
        const height = normalizeEditableNumber(rule?.height);
        const width = normalizeEditableNumber(rule?.width);
        const thickness = normalizeEditableNumber(rule?.thickness);
        const price = normalizeEditableNumber(rule?.price);
        const subscriberPrice = normalizeEditableNumber(rule?.subscriberPrice);
        const publicPrice = normalizeEditableNumber(rule?.publicPrice);
        const autoWeightKg = calcProductSizeWeightKg({ height, width, thickness }, densityKgM3);
        const weightManual = rule?.weightManual === true;
        const rawWeightKg = normalizeEditableNumber(rule?.weightKg);
        const weightKg = weightManual
            ? rawWeightKg
            : (toNumber(rawWeightKg) || autoWeightKg);

        const label = String(rule?.label || '').trim()
            || [height, width, thickness].filter((item) => item !== '').join('×')
            || `Размер ${index + 1}`;

        return {
            _clientId: rule?._clientId || rule?._id || `${Date.now()}-${index}`,
            sizeKey: createSharedSizeKey(rule, rule?.sizeKey),
            isBase: rule?.isBase === true,
            label,
            height,
            width,
            thickness,
            price,
            subscriberPrice,
            publicPrice,
            weightKg,
            weightManual,
            enabled: rule?.enabled !== false,
            note: String(rule?.note || '').trim(),
        };
    });
};


const getBlankDimensionsSignature = (dimensions = {}) => [
    Math.round(toNumber(dimensions?.height)),
    Math.round(toNumber(dimensions?.width)),
    Math.round(toNumber(dimensions?.thickness)),
].join('x');

const toPositiveBlankNumber = (value, fallback = 0) => {
    const number = toNumber(value);
    return number > 0 ? number : fallback;
};

const clampBlankNumber = (value, min, max, fallback = min) => {
    const number = Number(String(value ?? '').replace(',', '.'));
    if (!Number.isFinite(number)) return fallback;
    return Math.min(max, Math.max(min, number));
};

const normalizeBlankLookupOptions = (options = {}) => ({
    blankType: slugifyBlankMaterialKey(options.blankType || 'stele') || 'stele',
    polishingType: slugifyBlankMaterialKey(options.polishingType || 'two-side') || 'two-side',
    supplierKey: slugifyBlankMaterialKey(options.supplierKey || ''),
    allowEstimated: options.allowEstimated !== false,
    preferHighestPrice: options.preferHighestPrice === true,
});

const ruleMatchesBlankKind = (rule = {}, lookup = {}) => (
    slugifyBlankMaterialKey(rule.blankType || 'stele') === lookup.blankType
    && slugifyBlankMaterialKey(rule.polishingType || 'two-side') === lookup.polishingType
);

const resolveWorkingBlankOffer = (rule = {}) => {
    const offers = (Array.isArray(rule.supplierOffers) ? rule.supplierOffers : [])
        .filter((offer) => (
            offer?.enabled !== false
            && offer?.confirmed !== false
            && toPositiveBlankNumber(offer?.price, 0) > 0
        ));

    if (rule.priceSelectionMode === 'manual' && toPositiveBlankNumber(rule.manualPrice, 0) > 0) {
        return { price: toPositiveBlankNumber(rule.manualPrice, 0), supplierKey: '', source: 'manual' };
    }

    if (rule.priceSelectionMode === 'supplier' && rule.selectedSupplierKey) {
        const selectedKey = slugifyBlankMaterialKey(rule.selectedSupplierKey);
        const selected = offers.find((offer) => (
            slugifyBlankMaterialKey(offer.supplierKey) === selectedKey
        ));
        if (selected) {
            return {
                price: toPositiveBlankNumber(selected.price, 0),
                supplierKey: selectedKey,
                source: 'selected-supplier',
            };
        }
        return { price: 0, supplierKey: selectedKey, source: 'selected-supplier-missing' };
    }

    const cheapest = [...offers].sort((left, right) => (
        toPositiveBlankNumber(left.price, Number.POSITIVE_INFINITY)
        - toPositiveBlankNumber(right.price, Number.POSITIVE_INFINITY)
    ))[0];

    if (cheapest) {
        return {
            price: toPositiveBlankNumber(cheapest.price, 0),
            supplierKey: slugifyBlankMaterialKey(cheapest.supplierKey),
            source: 'cheapest-confirmed',
        };
    }

    if (toPositiveBlankNumber(rule.manualPrice, 0) > 0) {
        return { price: toPositiveBlankNumber(rule.manualPrice, 0), supplierKey: '', source: 'manual-fallback' };
    }

    if (toPositiveBlankNumber(rule.price, 0) > 0) {
        return { price: toPositiveBlankNumber(rule.price, 0), supplierKey: 'legacy', source: 'legacy' };
    }

    return { price: 0, supplierKey: '', source: 'missing' };
};

const getHighestSafeBlankRulePrice = (rule = {}) => {
    const candidates = [];

    (Array.isArray(rule?.supplierOffers) ? rule.supplierOffers : []).forEach((offer) => {
        if (
            offer?.enabled !== false
            && offer?.confirmed !== false
            && toPositiveBlankNumber(offer?.price, 0) > 0
        ) {
            candidates.push({
                price: toPositiveBlankNumber(offer.price, 0),
                kind: 'supplier',
                supplierKey: slugifyBlankMaterialKey(offer.supplierKey),
            });
        }
    });

    if (toPositiveBlankNumber(rule?.manualPrice, 0) > 0) {
        candidates.push({ price: toPositiveBlankNumber(rule.manualPrice, 0), kind: 'manual', supplierKey: '' });
    }
    if (toPositiveBlankNumber(rule?.price, 0) > 0) {
        candidates.push({ price: toPositiveBlankNumber(rule.price, 0), kind: 'legacy', supplierKey: '' });
    }

    return candidates.sort((left, right) => right.price - left.price)[0] || null;
};

const buildSafeBlankReferenceCatalog = (catalog = {}) => ({
    ...catalog,
    sizeRules: (Array.isArray(catalog?.sizeRules) ? catalog.sizeRules : []).map((rule) => {
        const highest = getHighestSafeBlankRulePrice(rule);
        if (!highest) return rule;

        if (highest.kind === 'supplier' && highest.supplierKey) {
            return {
                ...rule,
                priceSelectionMode: 'supplier',
                selectedSupplierKey: highest.supplierKey,
                price: highest.price,
                supplierOffers: (Array.isArray(rule?.supplierOffers) ? rule.supplierOffers : [])
                    .filter((offer) => slugifyBlankMaterialKey(offer?.supplierKey) === highest.supplierKey),
            };
        }

        return {
            ...rule,
            priceSelectionMode: 'manual',
            manualPrice: highest.price,
            price: highest.price,
            selectedSupplierKey: '',
            supplierOffers: [],
        };
    }),
});

const getBlankRulePricePriority = (rule = {}) => {
    const hasConfirmedSupplier = (Array.isArray(rule?.supplierOffers) ? rule.supplierOffers : [])
        .some((offer) => (
            offer?.enabled !== false
            && offer?.confirmed !== false
            && toPositiveBlankNumber(offer?.price, 0) > 0
        ));
    if (hasConfirmedSupplier) return 3;
    if (toPositiveBlankNumber(rule?.manualPrice, 0) > 0) return 2;
    if (toPositiveBlankNumber(rule?.price, 0) > 0) return 1;
    return 0;
};

const calculateBlankRulePrice = (rule = {}, dimensions = {}, supplierKey = '') => {
    const height = toPositiveBlankNumber(dimensions.height, 0);
    const width = toPositiveBlankNumber(dimensions.width, 0);
    const thickness = toPositiveBlankNumber(dimensions.thickness, 0);
    const areaM2 = (height * width) / 1_000_000;
    const volumeM3 = (height * width * thickness) / 1_000_000_000;
    let working = resolveWorkingBlankOffer(rule);

    if (supplierKey) {
        const offer = (Array.isArray(rule.supplierOffers) ? rule.supplierOffers : []).find((item) => (
            slugifyBlankMaterialKey(item?.supplierKey) === supplierKey
            && item?.enabled !== false
            && item?.confirmed !== false
            && toPositiveBlankNumber(item?.price, 0) > 0
        ));
        if (!offer) {
            return { price: 0, supplierKey, source: 'missing-supplier-offer', areaM2, volumeM3 };
        }
        working = {
            price: toPositiveBlankNumber(offer.price, 0),
            supplierKey,
            source: 'requested-supplier',
        };
    }

    if (!(working.price > 0)) {
        return { price: 0, supplierKey: working.supplierKey, source: working.source, areaM2, volumeM3 };
    }

    const priceUnit = rule.priceUnit || 'piece';
    if (priceUnit === 'squareMeter') {
        return {
            price: working.price * areaM2,
            unitPrice: working.price,
            supplierKey: working.supplierKey,
            source: working.source,
            areaM2,
            volumeM3,
        };
    }
    if (priceUnit === 'cubicMeter') {
        return {
            price: working.price * volumeM3,
            unitPrice: working.price,
            supplierKey: working.supplierKey,
            source: working.source,
            areaM2,
            volumeM3,
        };
    }

    return {
        price: working.price,
        supplierKey: working.supplierKey,
        source: working.source,
        areaM2,
        volumeM3,
    };
};

export const findExactBlankPriceRule = (catalog, dimensions, options = {}) => {
    if (!catalog || !Array.isArray(catalog.sizeRules)) return null;

    const lookup = normalizeBlankLookupOptions(options);
    const signature = getBlankDimensionsSignature(dimensions);
    const areaM2 = (
        toPositiveBlankNumber(dimensions.height, 0)
        * toPositiveBlankNumber(dimensions.width, 0)
    ) / 1_000_000;

    const matches = catalog.sizeRules.filter((rule) => {
        if (rule?.enabled === false || !ruleMatchesBlankKind(rule, lookup)) return false;

        if ((rule.priceUnit || 'piece') === 'squareMeter') {
            const sameThickness = Math.round(toPositiveBlankNumber(rule.thickness, 0))
                === Math.round(toPositiveBlankNumber(dimensions.thickness, 0));
            const minArea = toNumber(rule.minAreaM2);
            const maxArea = toNumber(rule.maxAreaM2);
            const insideBand = (!minArea || areaM2 >= minArea) && (!maxArea || areaM2 <= maxArea);
            return sameThickness
                && insideBand
                && calculateBlankRulePrice(rule, dimensions, lookup.supplierKey).price > 0;
        }

        return getBlankDimensionsSignature(rule) === signature
            && calculateBlankRulePrice(rule, dimensions, lookup.supplierKey).price > 0;
    });

    matches.sort((left, right) => {
        if (lookup.preferHighestPrice) {
            const leftPrice = calculateBlankRulePrice(left, dimensions, lookup.supplierKey).price;
            const rightPrice = calculateBlankRulePrice(right, dimensions, lookup.supplierKey).price;
            if (rightPrice !== leftPrice) return rightPrice - leftPrice;
        }
        return getBlankRulePricePriority(right) - getBlankRulePricePriority(left);
    });
    return matches[0] || null;
};

const getBlankEstimationStrategy = (rules = [], dimensions = {}, blankType = 'stele') => {
    const normalizedType = slugifyBlankMaterialKey(blankType || 'stele') || 'stele';
    const targetWidth = Math.round(toPositiveBlankNumber(dimensions.width, 0));
    const targetThickness = Math.round(toPositiveBlankNumber(dimensions.thickness, 0));

    if (normalizedType === 'base' || normalizedType === 'flower-bed') {
        const sameCrossSection = rules.filter((rule) => (
            Math.round(toPositiveBlankNumber(rule.width, 0)) === targetWidth
            && Math.round(toPositiveBlankNumber(rule.thickness, 0)) === targetThickness
        ));
        if (sameCrossSection.length >= 2) {
            return { rules: sameCrossSection, metric: 'length', confidenceBoost: true };
        }
    }

    if (normalizedType === 'stele') {
        const sameThickness = rules.filter((rule) => (
            Math.round(toPositiveBlankNumber(rule.thickness, 0)) === targetThickness
        ));
        if (sameThickness.length >= 2) {
            return { rules: sameThickness, metric: 'area', confidenceBoost: true };
        }
    }

    if (normalizedType === 'slab') {
        return { rules, metric: 'area', confidenceBoost: rules.length >= 2 };
    }

    return { rules, metric: 'volume', confidenceBoost: false };
};

const getBlankEstimationMetric = (dimensions = {}, metric = 'volume') => {
    const height = toPositiveBlankNumber(dimensions.height, 0);
    const width = toPositiveBlankNumber(dimensions.width, 0);
    const thickness = toPositiveBlankNumber(dimensions.thickness, 0);

    if (metric === 'length') return height / 1000;
    if (metric === 'area') return (height * width) / 1_000_000;
    return (height * width * thickness) / 1_000_000_000;
};

const estimateBlankPriceForSupplier = ({
    catalog,
    dimensions,
    lookup,
    supplierKey = '',
    useWorkingOffers = false,
}) => {
    const sourceRules = (Array.isArray(catalog?.sizeRules) ? catalog.sizeRules : [])
        .filter((rule) => (
            rule?.enabled !== false
            && (rule.priceUnit || 'piece') === 'piece'
            && ruleMatchesBlankKind(rule, lookup)
        ));
    const strategy = getBlankEstimationStrategy(sourceRules, dimensions, lookup.blankType);
    const targetMetric = getBlankEstimationMetric(dimensions, strategy.metric);

    const prepared = strategy.rules.map((rule) => {
        const resolved = calculateBlankRulePrice(rule, rule, useWorkingOffers ? '' : supplierKey);
        const metric = getBlankEstimationMetric(rule, strategy.metric);
        const aspect = toPositiveBlankNumber(rule.width, 0) > 0
            ? toPositiveBlankNumber(rule.height, 0) / toPositiveBlankNumber(rule.width, 1)
            : 1;
        const targetAspect = toPositiveBlankNumber(dimensions.width, 0) > 0
            ? toPositiveBlankNumber(dimensions.height, 0) / toPositiveBlankNumber(dimensions.width, 1)
            : 1;
        const aspectPenalty = strategy.metric === 'area' || strategy.metric === 'volume'
            ? Math.abs(Math.log(Math.max(0.01, aspect / targetAspect)))
            : 0;

        return {
            rule,
            price: resolved.price,
            supplierKey: resolved.supplierKey,
            metric,
            aspectPenalty,
            distance: Math.abs(Math.log(Math.max(0.000001, metric / targetMetric))),
        };
    }).filter((item) => item.price > 0 && item.metric > 0);

    if (prepared.length < 2 || !(targetMetric > 0)) {
        return {
            price: 0,
            source: 'missing-estimation-data',
            label: 'Недостаточно цен поставщика для оценки',
            supplierKey,
            confidence: 'none',
            references: [],
        };
    }

    prepared.sort((left, right) => (
        (left.distance + left.aspectPenalty * 0.35)
        - (right.distance + right.aspectPenalty * 0.35)
    ));
    const nearest = prepared.slice(0, Math.min(5, prepared.length));

    let weightedRate = 0;
    let weightTotal = 0;
    nearest.forEach((item) => {
        const weight = 1 / Math.max(0.08, item.distance + item.aspectPenalty * 0.35);
        weightedRate += (item.price / item.metric) * weight;
        weightTotal += weight;
    });

    const minMetric = Math.min(...prepared.map((item) => item.metric));
    const maxMetric = Math.max(...prepared.map((item) => item.metric));
    const outsideRatio = targetMetric > maxMetric
        ? targetMetric / maxMetric
        : targetMetric < minMetric
            ? minMetric / targetMetric
            : 1;
    const extrapolationPremium = targetMetric > maxMetric
        ? 1 + Math.min(0.15, Math.log(outsideRatio) * 0.1)
        : 1;

    let baseRate = weightedRate / weightTotal;
    let shapePremium = 1;
    if (targetMetric > maxMetric) {
        const upperBoundary = [...prepared]
            .sort((left, right) => right.metric - left.metric)
            .slice(0, Math.min(3, prepared.length));
        baseRate = Math.max(...upperBoundary.map((item) => item.price / item.metric));

        if (strategy.metric === 'area' || strategy.metric === 'volume') {
            const boundaryRule = upperBoundary[0]?.rule || {};
            const boundaryAspect = toPositiveBlankNumber(boundaryRule.width, 0) > 0
                ? toPositiveBlankNumber(boundaryRule.height, 0) / toPositiveBlankNumber(boundaryRule.width, 1)
                : 1;
            const targetAspect = toPositiveBlankNumber(dimensions.width, 0) > 0
                ? toPositiveBlankNumber(dimensions.height, 0) / toPositiveBlankNumber(dimensions.width, 1)
                : 1;
            shapePremium = 1 + Math.min(
                0.1,
                Math.abs(Math.log(Math.max(0.01, targetAspect / boundaryAspect))) * 0.12
            );
        }
    }

    const rawPrice = baseRate * targetMetric * extrapolationPremium * shapePremium;
    const roundTo = toPositiveBlankNumber(catalog?.defaultRoundTo, 100);
    const price = Math.max(roundTo, Math.round(rawPrice / roundTo) * roundTo);

    let confidence = strategy.confidenceBoost ? 'high' : 'medium';
    if (outsideRatio > 1.6 || prepared.length < 3) confidence = 'low';
    else if (outsideRatio > 1.05 || !strategy.confidenceBoost) confidence = 'medium';

    const rangePercent = confidence === 'high' ? 0.08 : confidence === 'medium' ? 0.15 : 0.25;

    return {
        price,
        source: targetMetric >= minMetric && targetMetric <= maxMetric
            ? 'supplier-interpolation'
            : 'supplier-extrapolation',
        label: targetMetric >= minMetric && targetMetric <= maxMetric
            ? 'Предполагаемая цена между размерами поставщика'
            : 'Предполагаемая цена за пределами прайса поставщика',
        supplierKey: supplierKey || nearest[0]?.supplierKey || '',
        confidence,
        estimationMetric: strategy.metric,
        estimatedRange: {
            min: Math.max(0, Math.round(price * (1 - rangePercent) / roundTo) * roundTo),
            max: Math.round(price * (1 + rangePercent) / roundTo) * roundTo,
        },
        references: nearest.slice(0, 3).map((item) => ({
            label: item.rule.label || `${item.rule.height}×${item.rule.width}×${item.rule.thickness}`,
            dimensions: {
                height: toNumber(item.rule.height),
                width: toNumber(item.rule.width),
                thickness: toNumber(item.rule.thickness),
                unit: 'mm',
            },
            price: item.price,
            supplierKey: item.supplierKey,
        })),
    };
};

const estimateBlankPriceFromCatalog = ({ catalog, dimensions, options = {} }) => {
    const lookup = normalizeBlankLookupOptions(options);

    if (lookup.supplierKey) {
        return estimateBlankPriceForSupplier({
            catalog,
            dimensions,
            lookup,
            supplierKey: lookup.supplierKey,
        });
    }

    const supplierKeys = Array.from(new Set(
        (Array.isArray(catalog?.sizeRules) ? catalog.sizeRules : [])
            .filter((rule) => rule?.enabled !== false && ruleMatchesBlankKind(rule, lookup))
            .flatMap((rule) => (Array.isArray(rule.supplierOffers) ? rule.supplierOffers : []))
            .filter((offer) => (
                offer?.enabled !== false
                && offer?.confirmed !== false
                && toPositiveBlankNumber(offer?.price, 0) > 0
            ))
            .map((offer) => slugifyBlankMaterialKey(offer.supplierKey))
            .filter(Boolean)
    ));

    const supplierEstimates = supplierKeys
        .map((supplierKey) => estimateBlankPriceForSupplier({
            catalog,
            dimensions,
            lookup,
            supplierKey,
        }))
        .filter((estimate) => estimate.price > 0)
        .sort((left, right) => left.price - right.price);

    if (supplierEstimates.length) {
        const selected = supplierEstimates[0];
        return {
            ...selected,
            supplierEstimates: supplierEstimates.map((estimate) => ({
                supplierKey: estimate.supplierKey,
                price: estimate.price,
                confidence: estimate.confidence,
                estimatedRange: estimate.estimatedRange,
            })),
        };
    }

    return estimateBlankPriceForSupplier({
        catalog,
        dimensions,
        lookup,
        useWorkingOffers: true,
    });
};

const calculateBlankPriceDirect = ({
    catalog,
    dimensions,
    overridePrice = 0,
    blankType = 'stele',
    polishingType = 'two-side',
    supplierKey = '',
    allowEstimated = true,
    preferHighestPrice = false,
}) => {
    const manualPrice = toPositiveBlankNumber(overridePrice, 0);
    const height = toPositiveBlankNumber(dimensions?.height, 0);
    const width = toPositiveBlankNumber(dimensions?.width, 0);
    const thickness = toPositiveBlankNumber(dimensions?.thickness, 0);
    const volumeM3 = (height * width * thickness) / 1_000_000_000;
    const options = { blankType, polishingType, supplierKey, allowEstimated, preferHighestPrice };

    if (manualPrice > 0) {
        return {
            price: manualPrice,
            source: 'manual-blank',
            label: 'Цена заготовки указана вручную',
            rule: null,
            volumeM3,
            supplierKey: '',
            confidence: 'exact',
            estimated: false,
        };
    }

    if (!catalog || catalog?.enabled === false) {
        return {
            price: 0,
            source: catalog?.enabled === false ? 'disabled-material' : 'missing-material',
            label: catalog?.enabled === false
                ? 'Материал отключён в справочнике'
                : 'Материал не найден в справочнике',
            rule: null,
            volumeM3,
            supplierKey: '',
            confidence: 'none',
            estimated: false,
        };
    }

    const exactRule = findExactBlankPriceRule(catalog, dimensions, options);
    if (exactRule) {
        const resolved = calculateBlankRulePrice(
            exactRule,
            dimensions,
            slugifyBlankMaterialKey(supplierKey)
        );
        return {
            price: toNumber(resolved.price),
            source: 'exact-rule',
            label: exactRule.label || 'Точная цена заготовки',
            rule: exactRule,
            volumeM3,
            supplierKey: resolved.supplierKey,
            confidence: 'exact',
            estimated: false,
            priceUnit: exactRule.priceUnit || 'piece',
        };
    }

    if (allowEstimated !== false) {
        const estimate = estimateBlankPriceFromCatalog({ catalog, dimensions, options });
        if (estimate.price > 0) {
            return {
                ...estimate,
                rule: null,
                volumeM3,
                estimated: true,
            };
        }
    }

    const fallbackPricePerM3 = toNumber(catalog.fallbackPricePerCubicMeter);
    if (fallbackPricePerM3 > 0 && volumeM3 > 0) {
        return {
            price: fallbackPricePerM3 * volumeM3,
            source: 'volume-fallback',
            label: 'Резервная цена за м³',
            rule: null,
            volumeM3,
            supplierKey: '',
            confidence: 'low',
            estimated: true,
        };
    }

    return {
        price: 0,
        source: catalog?.priceRequestRequired === false ? 'missing-price' : 'price-request-required',
        label: catalog?.priceRequestRequired === false
            ? 'Для размера нет цены заготовки'
            : 'Цена заготовки требует запроса у поставщика',
        rule: null,
        volumeM3,
        supplierKey: slugifyBlankMaterialKey(supplierKey),
        confidence: 'none',
        estimated: false,
        requestRequired: catalog?.priceRequestRequired !== false,
    };
};

export const calcBlankPrice = (catalog, dimensions, optionsOrOverride = 0) => {
    const options = optionsOrOverride && typeof optionsOrOverride === 'object'
        ? optionsOrOverride
        : { overridePrice: optionsOrOverride };
    const direct = calculateBlankPriceDirect({
        catalog,
        dimensions,
        overridePrice: options.overridePrice,
        blankType: options.blankType || 'stele',
        polishingType: options.polishingType || 'two-side',
        supplierKey: options.supplierKey || '',
        allowEstimated: options.allowEstimated !== false,
    });

    if (
        direct.price > 0
        || toPositiveBlankNumber(options.overridePrice, 0) > 0
        || options.allowEstimated === false
    ) {
        return direct;
    }

    const catalogs = Array.isArray(options.catalogs) ? options.catalogs : [];
    const referenceKey = slugifyBlankMaterialKey(catalog?.referenceMaterialKey || '');
    const canUseReference = (
        catalog?.estimateFromReferenceEnabled === true
        && referenceKey
        && referenceKey !== slugifyBlankMaterialKey(catalog?.key)
        && catalogs.length > 0
    );

    if (!canUseReference) return direct;

    const referenceCatalog = getBlankMaterialCatalog(catalogs, referenceKey);
    if (!referenceCatalog || referenceCatalog.enabled === false) return direct;

    const safeReferenceCatalog = buildSafeBlankReferenceCatalog(referenceCatalog);
    const referenceResult = calculateBlankPriceDirect({
        catalog: safeReferenceCatalog,
        dimensions,
        overridePrice: 0,
        blankType: options.blankType || 'stele',
        polishingType: options.polishingType || 'two-side',
        supplierKey: '',
        allowEstimated: true,
        preferHighestPrice: true,
    });

    if (!(referenceResult.price > 0)) return direct;

    const multiplier = clampBlankNumber(catalog?.estimatedPriceMultiplier, 0.01, 20, 1);
    const roundTo = toPositiveBlankNumber(catalog?.defaultRoundTo, 100);
    const price = Math.max(
        roundTo,
        Math.round((referenceResult.price * multiplier) / roundTo) * roundTo
    );
    const sourceRange = referenceResult.estimatedRange || {
        min: referenceResult.price * 0.9,
        max: referenceResult.price * 1.1,
    };
    const rangePercent = referenceResult.confidence === 'low' ? 0.2 : 0.12;
    const minFromSource = toPositiveBlankNumber(sourceRange.min, referenceResult.price) * multiplier;
    const maxFromSource = toPositiveBlankNumber(sourceRange.max, referenceResult.price) * multiplier;

    return {
        ...referenceResult,
        price,
        source: 'reference-material-coefficient',
        label: `Безопасная оценка по верхней цене «${referenceCatalog.name}» × ${multiplier.toFixed(2)}`,
        rule: null,
        estimated: true,
        confidence: referenceResult.confidence === 'exact' ? 'medium' : referenceResult.confidence,
        referenceMaterialKey: referenceCatalog.key,
        referenceMaterialName: referenceCatalog.name,
        referenceBasePrice: toNumber(referenceResult.price),
        referenceMultiplier: multiplier,
        requestRequired: catalog?.priceRequestRequired !== false,
        estimatedRange: {
            min: Math.max(0, Math.round(Math.min(minFromSource, price * (1 - rangePercent)) / roundTo) * roundTo),
            max: Math.round(Math.max(maxFromSource, price * (1 + rangePercent)) / roundTo) * roundTo,
        },
        references: (referenceResult.references || []).map((reference) => ({
            ...reference,
            materialKey: referenceCatalog.key,
            materialName: referenceCatalog.name,
        })),
    };
};

export const normalizeProductPricing = (pricing, product, catalogs = []) => {
    const source = pricing && typeof pricing === 'object' ? pricing : {};
    const baseDimensionsFromProduct = getMillingDimensionsFromProduct(product);

    const sourceBaseDimensions = resolvePricingBaseDimensionsSource(source, product);
    const baseDimensions = normalizeMillingDimensions(
        sourceBaseDimensions,
        baseDimensionsFromProduct
    );

    const testDimensions = normalizeMillingDimensions(
        source.testDimensions || source.previewDimensions,
        baseDimensions
    );

    const density = hasOwn(source, 'materialDensityKgM3')
        ? normalizeEditableNumber(source.materialDensityKgM3)
        : DEFAULT_STONE_DENSITY_KG_M3;
    const sizeRules = normalizeProductSizeRules(source.sizeRules, density);
    const enabled = hasOwn(source, 'enabled')
        ? source.enabled === true
        : sizeRules.length > 0;
    const setupPercent = hasOwn(source, 'setupPercent')
        ? normalizeEditablePercent(source.setupPercent)
        : 10;
    const roundTo = toNumber(source.roundTo || 100) || 100;
    const basePrice = hasOwn(source, 'basePrice')
        ? normalizeEditableNumber(source.basePrice)
        : (toNumber(product?.price) || 0);
    const mode = ['volumeForward', 'blankPlusMilling', 'manual'].includes(source.mode)
        ? source.mode
        : 'volumeForward';
    const inferredMaterialKey = inferBlankMaterialKey(product, catalogs);
    const blankMaterialKey = slugifyBlankMaterialKey(
        source.blankMaterialKey || source.materialKey || inferredMaterialKey
    );
    const catalog = getBlankMaterialCatalog(catalogs, blankMaterialKey);

    return {
        enabled,
        mode,
        basePrice,
        baseDimensions,
        testDimensions,
        setupPercent,
        roundTo,
        materialDensityKgM3: density,
        materialDensityLabel: String(
            catalog?.name
            || source.materialDensityLabel
            || 'Габбро-диабаз'
        ),
        blankMaterialKey,
        blankMaterialName: String(catalog?.name || source.blankMaterialName || ''),
        blankPriceOverride: hasOwn(source, 'blankPriceOverride')
            ? normalizeEditableNumber(source.blankPriceOverride)
            : 0,
        blankType: slugifyBlankMaterialKey(source.blankType || 'stele') || 'stele',
        blankPolishingType: slugifyBlankMaterialKey(
            source.blankPolishingType || source.polishingType || 'two-side'
        ) || 'two-side',
        blankSupplierKey: slugifyBlankMaterialKey(source.blankSupplierKey || ''),
        allowEstimatedBlankPrice: source.allowEstimatedBlankPrice !== false,
        blankSizingMode: normalizeBlankSizingMode(source.blankSizingMode),
        blankWidthStepMm: Math.max(1, toNumber(source.blankWidthStepMm) || 50),
        blankHeightStepMm: Math.max(1, toNumber(source.blankHeightStepMm) || 50),
        blankThicknessStepMm: Math.max(1, toNumber(source.blankThicknessStepMm) || 10),
        blankMinimumThicknessMm: Math.max(1, toNumber(source.blankMinimumThicknessMm) || 30),
        manualBlankDimensions: normalizeMillingDimensions(source.manualBlankDimensions, baseDimensions),
        totalMarkupPercent: hasOwn(source, 'totalMarkupPercent')
            ? normalizeEditablePercent(source.totalMarkupPercent)
            : normalizeEditablePercent(catalog?.defaultMarkupPercent ?? 20),
        minimumPrice: hasOwn(source, 'minimumPrice')
            ? normalizeEditableNumber(source.minimumPrice)
            : normalizeEditableNumber(catalog?.defaultMinimumPrice ?? 0),
        manualPrice: hasOwn(source, 'manualPrice')
            ? normalizeEditableNumber(source.manualPrice)
            : (mode === 'manual' ? basePrice : 0),
        blankCatalogRevision: toNumber(source.blankCatalogRevision),
        blankPriceCalculated: toNumber(source.blankPriceCalculated),
        millingPriceCalculated: toNumber(source.millingPriceCalculated),
        subtotalCalculated: toNumber(source.subtotalCalculated),
        calculatedPrice: toNumber(source.calculatedPrice),
        subscriberPriceCalculated: toNumber(source.subscriberPriceCalculated),
        publicPriceCalculated: toNumber(source.publicPriceCalculated),
        calculationSource: String(source.calculationSource || ''),
        blankPriceConfidence: String(source.blankPriceConfidence || ''),
        blankPriceEstimated: source.blankPriceEstimated === true,
        blankPriceRequestRequired: source.blankPriceRequestRequired === true,
        blankSupplierCalculatedKey: slugifyBlankMaterialKey(source.blankSupplierCalculatedKey || ''),
        blankReferenceMaterialKey: slugifyBlankMaterialKey(source.blankReferenceMaterialKey || ''),
        blankReferenceMaterialName: String(source.blankReferenceMaterialName || ''),
        blankReferenceMultiplier: toNumber(source.blankReferenceMultiplier) || 1,
        blankEstimatedMin: toNumber(source.blankEstimatedMin),
        blankEstimatedMax: toNumber(source.blankEstimatedMax),
        calculatedAt: source.calculatedAt || null,
        sizeRules,
    };
};

export const normalizeProductPricingForSave = (pricing, product, context = {}) => {
    const catalogs = context.blankPriceCatalogs || [];
    const millingPricing = context.millingPricing || product?.millingPricing || {};
    const millingFallbackPrice = context.millingFallbackPrice ?? product?.workPrice ?? 0;
    const normalized = normalizeProductPricing(pricing, product, catalogs);
    const basePreview = calcProductPrice(
        { ...normalized, sizeRules: [] },
        normalized.baseDimensions,
        product?.price,
        {
            blankPriceCatalogs: catalogs,
            millingPricing,
            millingFallbackPrice,
            pricingPolicy: context.pricingPolicy || {},
            workOptions: context.workOptions || [],
        }
    );
    const effectiveBasePrice = normalized.mode === 'volumeForward'
        ? toNumber(normalized.basePrice)
        : toNumber(basePreview.price);
    const baseCustomerPrices = calcProductCustomerPrices({
        blankPrice: basePreview.blankPrice,
        millingPrice: basePreview.millingPrice,
        worksPrice: basePreview.worksPrice,
        fallbackPrice: basePreview.price,
        pricingPolicy: context.pricingPolicy || {},
    });

    return {
        enabled: !!normalized.enabled,
        mode: normalized.mode,
        basePrice: effectiveBasePrice,
        baseDimensions: {
            height: toNumber(normalized.baseDimensions.height),
            width: toNumber(normalized.baseDimensions.width),
            thickness: toNumber(normalized.baseDimensions.thickness),
            unit: 'mm',
        },
        setupPercent: Math.min(300, Math.max(0, toNumber(normalized.setupPercent))),
        roundTo: toNumber(normalized.roundTo) || 100,
        materialDensityKgM3: toNumber(normalized.materialDensityKgM3),
        materialDensityLabel: String(normalized.materialDensityLabel || 'Габбро-диабаз').trim(),
        blankMaterialKey: slugifyBlankMaterialKey(normalized.blankMaterialKey),
        blankMaterialName: String(basePreview.materialName || normalized.blankMaterialName || '').trim(),
        blankPriceOverride: toNumber(normalized.blankPriceOverride),
        blankType: slugifyBlankMaterialKey(normalized.blankType || 'stele') || 'stele',
        blankPolishingType: slugifyBlankMaterialKey(normalized.blankPolishingType || 'two-side') || 'two-side',
        blankSupplierKey: slugifyBlankMaterialKey(normalized.blankSupplierKey || ''),
        allowEstimatedBlankPrice: normalized.allowEstimatedBlankPrice !== false,
        blankSizingMode: normalizeBlankSizingMode(normalized.blankSizingMode),
        blankWidthStepMm: Math.max(1, toNumber(normalized.blankWidthStepMm) || 50),
        blankHeightStepMm: Math.max(1, toNumber(normalized.blankHeightStepMm) || 50),
        blankThicknessStepMm: Math.max(1, toNumber(normalized.blankThicknessStepMm) || 10),
        blankMinimumThicknessMm: Math.max(1, toNumber(normalized.blankMinimumThicknessMm) || 30),
        manualBlankDimensions: {
            height: toNumber(normalized.manualBlankDimensions?.height),
            width: toNumber(normalized.manualBlankDimensions?.width),
            thickness: toNumber(normalized.manualBlankDimensions?.thickness),
            unit: 'mm',
        },
        totalMarkupPercent: Math.min(500, Math.max(0, toNumber(normalized.totalMarkupPercent))),
        minimumPrice: toNumber(normalized.minimumPrice),
        manualPrice: toNumber(normalized.manualPrice),
        blankCatalogRevision: toNumber(basePreview.catalogRevision || normalized.blankCatalogRevision),
        blankPriceCalculated: toNumber(basePreview.blankPrice),
        millingPriceCalculated: toNumber(basePreview.millingPrice),
        subtotalCalculated: toNumber(basePreview.subtotal),
        calculatedPrice: toNumber(basePreview.price),
        subscriberPriceCalculated: toNumber(baseCustomerPrices.subscriberPrice),
        publicPriceCalculated: toNumber(baseCustomerPrices.publicPrice),
        calculationSource: String(basePreview.blankSource || normalized.calculationSource || ''),
        blankPriceConfidence: String(basePreview.blankConfidence || normalized.blankPriceConfidence || ''),
        blankPriceEstimated: basePreview.blankEstimated === true,
        blankPriceRequestRequired: basePreview.blankRequestRequired === true,
        blankSupplierCalculatedKey: slugifyBlankMaterialKey(basePreview.blankSupplierKey || ''),
        blankReferenceMaterialKey: slugifyBlankMaterialKey(basePreview.blankReferenceMaterialKey || ''),
        blankReferenceMaterialName: String(basePreview.blankReferenceMaterialName || ''),
        blankReferenceMultiplier: toNumber(basePreview.blankReferenceMultiplier) || 1,
        blankEstimatedMin: toNumber(basePreview.blankEstimatedRange?.min),
        blankEstimatedMax: toNumber(basePreview.blankEstimatedRange?.max),
        calculatedAt: basePreview.catalogUpdatedAt || normalized.calculatedAt || null,
        sizeRules: normalized.sizeRules
            .filter((rule) => (
                toNumber(rule.height) > 0 &&
                toNumber(rule.width) > 0 &&
                toNumber(rule.thickness) > 0
            ))
            .map((rule) => {
            const autoWeightKg = calcProductSizeWeightKg(rule, normalized.materialDensityKgM3);
            const calculated = calcProductPrice(
                {
                    ...normalized,
                    enabled: true,
                    sizeRules: [],
                },
                rule,
                product?.price,
                {
                    blankPriceCatalogs: catalogs,
                    millingPricing,
                    millingFallbackPrice,
                    pricingPolicy: context.pricingPolicy || {},
                    workOptions: context.workOptions || [],
                }
            );
            const customerPrices = calcProductCustomerPrices({
                blankPrice: calculated.blankPrice,
                millingPrice: calculated.millingPrice,
                worksPrice: calculated.worksPrice,
                fallbackPrice: calculated.price,
                pricingPolicy: context.pricingPolicy || {},
            });

            return {
                sizeKey: createSharedSizeKey(rule, rule.sizeKey),
                isBase: rule.isBase === true,
                label: String(rule.label || '').trim(),
                height: toNumber(rule.height),
                width: toNumber(rule.width),
                thickness: toNumber(rule.thickness),
                price: toNumber(calculated.price),
                subscriberPrice: toNumber(customerPrices.subscriberPrice),
                publicPrice: toNumber(customerPrices.publicPrice),
                weightKg: rule.weightManual ? toNumber(rule.weightKg) : autoWeightKg,
                weightManual: rule.weightManual === true,
                enabled: rule.enabled !== false,
                note: String(rule.note || '').trim(),
            };
        }),
    };
};

export const findExactProductRule = (pricing, dimensions) => {
    const normalized = normalizeProductPricing(pricing);
    const dims = normalizeMillingDimensions(dimensions, normalized.baseDimensions);

    return normalized.sizeRules.find((rule) => {
        if (rule.enabled === false) return false;
        if (!isSameMm(rule.height, dims.height)) return false;
        if (!isSameMm(rule.width, dims.width)) return false;

        if (rule.thickness > 0 && dims.thickness > 0) {
            return isSameMm(rule.thickness, dims.thickness);
        }

        return true;
    }) || null;
};

export const calcProductPrice = (pricing, dimensions, fallbackPrice = 0, context = {}) => {
    const catalogs = context.blankPriceCatalogs || [];
    const normalized = normalizeProductPricing(pricing, context.product, catalogs);
    const dims = normalizeMillingDimensions(dimensions, normalized.baseDimensions);
    const weightKg = calcProductSizeWeightKg(dims, normalized.materialDensityKgM3);
    /*
     * Точные цены размеров остаются приоритетом только для прежней
     * объёмной схемы. В режимах «заготовка + фрезеровка» и «ручная цена»
     * итог должен сразу отражать текущую формулу, а не сохранённую ранее
     * цену правила размера. При сохранении цены правил пересчитываются.
     */
    const exactRule = normalized.enabled && normalized.mode === 'volumeForward'
        ? findExactProductRule(normalized, dims)
        : null;

    if (exactRule) {
        return {
            price: toNumber(exactRule.price) || toNumber(fallbackPrice) || normalized.basePrice,
            weightKg: toNumber(exactRule.weightKg) || weightKg,
            source: 'rule',
            label: `Точная цена размера: ${exactRule.label}`,
            rule: exactRule,
            ratio: 1,
            volumeRatio: 1,
            rawVolumeRatio: 1,
            increasePercent: 0,
            rawPrice: toNumber(exactRule.price),
            baseVolume: 0,
            currentVolume: 0,
            blankPrice: 0,
            millingPrice: 0,
            subtotal: 0,
        };
    }

    const fallback = toNumber(fallbackPrice);

    if (!normalized.enabled) {
        return {
            price: fallback || normalized.basePrice,
            weightKg,
            source: fallback || normalized.basePrice ? 'old' : 'none',
            label: fallback || normalized.basePrice ? 'Основная цена товара' : 'Цена не указана',
            rule: null,
            ratio: 1,
            volumeRatio: 1,
            rawVolumeRatio: 1,
            increasePercent: 0,
            rawPrice: fallback || normalized.basePrice,
            baseVolume: 0,
            currentVolume: 0,
            blankPrice: 0,
            millingPrice: 0,
            subtotal: 0,
        };
    }

    if (normalized.mode === 'manual') {
        const manualPrice = toNumber(normalized.manualPrice) || toNumber(normalized.basePrice) || fallback;
        return {
            price: manualPrice,
            weightKg,
            source: manualPrice > 0 ? 'manual' : 'none',
            label: manualPrice > 0 ? 'Ручная итоговая цена изделия' : 'Ручная цена не указана',
            rule: null,
            ratio: 1,
            volumeRatio: 1,
            rawVolumeRatio: 1,
            increasePercent: 0,
            rawPrice: manualPrice,
            baseVolume: 0,
            currentVolume: 0,
            blankPrice: 0,
            millingPrice: 0,
            subtotal: manualPrice,
        };
    }

    if (normalized.mode === 'blankPlusMilling') {
        const catalog = getBlankMaterialCatalog(catalogs, normalized.blankMaterialKey);
        const blankDimensions = resolveBlankDimensions(dims, normalized, context.pricingPolicy || {});
        const blank = calcBlankPrice(catalog, blankDimensions, {
            overridePrice: normalized.blankPriceOverride,
            blankType: normalized.blankType || 'stele',
            polishingType: normalized.blankPolishingType || 'two-side',
            supplierKey: normalized.blankSupplierKey || '',
            allowEstimated: normalized.allowEstimatedBlankPrice !== false,
            catalogs,
        });
        const legacyMilling = applyMaterialMillingMarkup(
            calcMillingPrice(
                context.millingPricing || {},
                dims,
                context.millingFallbackPrice || 0,
                context.pricingPolicy || {}
            ),
            catalog,
            context.pricingPolicy || {}
        );
        const workSummary = Array.isArray(context.workOptions) && context.workOptions.length
            ? calcWorkOptionsTotal(
                context.workOptions,
                dims,
                context.pricingPolicy || {},
                {
                    millingPricingOverride: context.millingPricing || null,
                    millingFallbackPrice: context.millingFallbackPrice || 0,
                    materialCatalog: catalog,
                }
            )
            : {
                items: legacyMilling.price > 0 ? [{
                    key: 'milling',
                    name: 'Фрезеровка',
                    workType: 'milling',
                    enabled: true,
                    price: toNumber(legacyMilling.price),
                    source: legacyMilling.source,
                }] : [],
                total: toNumber(legacyMilling.price),
                millingPrice: toNumber(legacyMilling.price),
                additionalWorksPrice: 0,
                enabledCount: legacyMilling.price > 0 ? 1 : 0,
            };
        const subtotal = toNumber(blank.price) + toNumber(workSummary.total);
        const roundTo = toNumber(normalized.roundTo) || toNumber(catalog?.defaultRoundTo) || 100;
        const price = subtotal > 0 ? Math.round(subtotal / roundTo) * roundTo : 0;

        return {
            price,
            weightKg,
            source: blank.price > 0 ? 'blank-plus-works' : 'none',
            label: blank.price <= 0
                ? blank.label
                : workSummary.enabledCount > 0
                    ? 'Заготовка + работы (до глобального распределения)'
                    : 'Заготовка без дополнительных работ (до глобального распределения)',
            rule: null,
            ratio: subtotal > 0 ? price / subtotal : 1,
            volumeRatio: 1,
            rawVolumeRatio: 1,
            increasePercent: 0,
            rawPrice: subtotal,
            baseVolume: 0,
            currentVolume: blank.volumeM3 * 1000000000,
            blankPrice: toNumber(blank.price),
            blankSource: blank.source,
            blankSourceLabel: blank.label,
            blankSupplierKey: blank.supplierKey || '',
            blankConfidence: blank.confidence || '',
            blankEstimated: blank.estimated === true,
            blankRequestRequired: blank.requestRequired === true,
            blankEstimatedRange: blank.estimatedRange || null,
            blankReferences: blank.references || [],
            blankReferenceMaterialKey: blank.referenceMaterialKey || '',
            blankReferenceMaterialName: blank.referenceMaterialName || '',
            blankReferenceBasePrice: toNumber(blank.referenceBasePrice),
            blankReferenceMultiplier: toNumber(blank.referenceMultiplier) || 1,
            millingPrice: toNumber(workSummary.millingPrice),
            millingSource: legacyMilling.source,
            millingBasePriceBeforeMaterialMarkup: toNumber(legacyMilling.basePriceBeforeMaterialMarkup),
            materialMillingMarkupPercent: toNumber(legacyMilling.materialMarkupPercent),
            materialMillingMarkupAmount: toNumber(legacyMilling.materialMarkupAmount),
            additionalWorksPrice: toNumber(workSummary.additionalWorksPrice),
            worksPrice: toNumber(workSummary.total),
            workItems: workSummary.items,
            subtotal,
            minimumPrice: 0,
            blankDimensions,
            productDimensions: dims,
            materialKey: normalized.blankMaterialKey,
            materialName: catalog?.name || normalized.blankMaterialName || '',
            catalogRevision: toNumber(catalog?.revision),
            catalogUpdatedAt: catalog?.updatedAt || null,
            roundTo,
        };
    }

    const basePrice = toNumber(normalized.basePrice) || fallback;

    if (!basePrice) {
        return {
            price: 0,
            weightKg,
            source: 'none',
            label: 'Нет цены базового размера',
            rule: null,
            ratio: 1,
            volumeRatio: 1,
            rawVolumeRatio: 1,
            increasePercent: 0,
            rawPrice: 0,
            baseVolume: 0,
            currentVolume: 0,
            blankPrice: 0,
            millingPrice: 0,
            subtotal: 0,
        };
    }

    const baseHeight = toNumber(normalized.baseDimensions.height) || 1000;
    const baseWidth = toNumber(normalized.baseDimensions.width) || 500;
    const baseThickness = toNumber(normalized.baseDimensions.thickness) || 80;
    const currentHeight = toNumber(dims.height) || baseHeight;
    const currentWidth = toNumber(dims.width) || baseWidth;
    const currentThickness = toNumber(dims.thickness) || baseThickness;
    const baseVolume = baseHeight * baseWidth * baseThickness;
    const currentVolume = currentHeight * currentWidth * currentThickness;
    const rawVolumeRatio = baseVolume > 0 ? currentVolume / baseVolume : 1;
    const volumeRatio = Math.max(1, rawVolumeRatio);
    const increasePercent = volumeRatio > 1
        ? Math.min(300, Math.max(0, toNumber(normalized.setupPercent))) / 100
        : 0;
    const finalRatio = volumeRatio > 1
        ? volumeRatio * (1 + increasePercent)
        : 1;
    const roundTo = toNumber(normalized.roundTo) || 100;
    const rawPrice = basePrice * finalRatio;
    const price = Math.round(rawPrice / roundTo) * roundTo;

    return {
        price,
        weightKg,
        source: 'formula',
        label: 'Базовая цена × объём + наценка, только вверх',
        rule: null,
        ratio: finalRatio,
        volumeRatio,
        rawVolumeRatio,
        increasePercent: increasePercent * 100,
        rawPrice,
        baseVolume,
        currentVolume,
        blankPrice: 0,
        millingPrice: 0,
        subtotal: 0,
    };
};

const getDefaultWorkName = (workType = 'milling') => {
    if (workType === 'polishing') return 'Полировка';
    if (workType === 'engraving') return 'Гравировка';
    if (workType === 'installation') return 'Монтаж';
    if (workType === 'custom') return 'Работа';

    return 'Фрезеровка';
};

const getWorkKey = (workType = 'milling', index = 0) => {
    const clean = String(workType || 'milling').trim() || 'milling';

    return index ? `${clean}-${index + 1}` : clean;
};

export const normalizeWorkOption = (value = {}, product = null, index = 0) => {
    const fallbackType = product?.workType && product.workType !== 'none'
        ? product.workType
        : 'milling';

    const workType = String(value?.workType || value?.type || fallbackType || 'milling');
    const name = String(value?.name || value?.label || product?.workLabel || getDefaultWorkName(workType)).trim();
    const calcMode = value?.calcMode || value?.workCalcMode || product?.workCalcMode || 'fixed';

    const pricing = normalizeMillingPricing(
        value?.pricing || value?.millingPricing || product?.millingPricing,
        product
    );

    const price = toNumber(value?.price ?? value?.workPrice ?? product?.workPrice);
    const pricePerMeter = toNumber(value?.pricePerMeter ?? value?.workPricePerMeter ?? product?.workPricePerMeter);
    const pricePerSquareMeter = toNumber(value?.pricePerSquareMeter ?? value?.workPricePerSquareMeter ?? product?.workPricePerSquareMeter);
    const pricePerCubicMeter = toNumber(value?.pricePerCubicMeter ?? value?.workPricePerCubicMeter ?? product?.workPricePerCubicMeter);

    const hasPrice =
        price > 0 ||
        pricePerMeter > 0 ||
        pricePerSquareMeter > 0 ||
        pricePerCubicMeter > 0 ||
        pricing.enabled === true ||
        pricing.sizeRules.length > 0 ||
        pricing.basePrice > 0;

    const enabled = value?.enabled !== undefined
        ? value.enabled !== false
        : hasPrice && product?.workType !== 'none';

    return {
        key: String(value?.key || getWorkKey(workType, index)),
        name: name || getDefaultWorkName(workType),
        enabled,
        workType,
        calcMode: ['fixed', 'linearMeter', 'squareMeter', 'cubicMeter'].includes(calcMode) ? calcMode : 'fixed',
        price,
        pricePerMeter,
        pricePerSquareMeter,
        pricePerCubicMeter,
        pricing,
        sortOrder: toNumber(value?.sortOrder ?? index),
        note: String(value?.note || ''),
    };
};

export const normalizeWorkOptions = (product) => {
    const source = Array.isArray(product?.workOptions)
        ? product.workOptions
        : [];

    if (source.length) {
        return source.map((item, index) => normalizeWorkOption(item, product, index));
    }

    const fallback = normalizeWorkOption({}, product, 0);

    return fallback.enabled ? [fallback] : [];
};

const getMetricWorkDimensions = (dimensions = {}) => {
    const unit = String(dimensions?.unit || 'mm').toLowerCase();
    const factor = unit === 'mm' ? 1 / 1000 : 1;
    const height = Math.max(0, toNumber(dimensions?.height) * factor);
    const width = Math.max(0, toNumber(dimensions?.width) * factor);
    const thickness = Math.max(0, toNumber(dimensions?.thickness ?? dimensions?.length) * factor);

    return {
        height,
        width,
        thickness,
        linearMeters: Math.max(height, width),
        area: height * width,
        volume: height * width * thickness,
    };
};

export const calcWorkOptionPrice = (value = {}, dimensions = {}, policy = {}) => {
    const work = normalizeWorkOption(value);
    if (work.enabled === false) {
        return { price: 0, source: 'disabled', work };
    }

    const exactRule = findExactMillingRule(work.pricing, dimensions);
    if (exactRule && toNumber(exactRule.price) > 0) {
        return {
            price: toNumber(exactRule.price),
            source: 'size-rule',
            rule: exactRule,
            work,
        };
    }

    if (work.workType === 'milling' && work.pricing?.enabled === true) {
        const preview = calcMillingPrice(work.pricing, dimensions, work.price, policy);
        return { ...preview, work };
    }

    if (work.pricing?.enabled === true && toNumber(work.pricing?.basePrice) > 0) {
        const preview = calcMillingPrice(work.pricing, dimensions, work.price, policy);
        return { ...preview, work };
    }

    const metric = getMetricWorkDimensions(dimensions);
    let price = 0;

    if (work.calcMode === 'linearMeter') {
        price = metric.linearMeters * toNumber(work.pricePerMeter);
    } else if (work.calcMode === 'squareMeter') {
        price = metric.area * toNumber(work.pricePerSquareMeter);
    } else if (work.calcMode === 'cubicMeter') {
        price = metric.volume * toNumber(work.pricePerCubicMeter);
    } else {
        price = toNumber(work.price);
    }

    return {
        price: Math.max(0, Math.round((price + Number.EPSILON) * 100) / 100),
        source: work.calcMode || 'fixed',
        work,
    };
};

export const calcWorkOptionsTotal = (workOptions = [], dimensions = {}, policy = {}, options = {}) => {
    const source = Array.isArray(workOptions) ? workOptions : [];
    const millingOverride = options?.millingPricingOverride || null;
    const millingFallbackPrice = toNumber(options?.millingFallbackPrice);
    const items = source
        .map((item, index) => {
            const normalized = normalizeWorkOption(item, null, index);
            const isMilling = normalized.workType === 'milling' || normalized.key === 'milling';
            const effective = isMilling && millingOverride
                ? {
                    ...normalized,
                    price: toNumber(normalized.price) || millingFallbackPrice,
                    pricing: millingOverride,
                }
                : normalized;
            const rawPreview = calcWorkOptionPrice(effective, dimensions, policy);
            const preview = isMilling
                ? applyMaterialMillingMarkup(rawPreview, options?.materialCatalog || null, policy)
                : rawPreview;

            return {
                key: effective.key,
                name: effective.name,
                workType: effective.workType,
                enabled: effective.enabled !== false,
                price: toNumber(preview.price),
                source: preview.source || '',
                preview,
            };
        })
        .filter((item) => item.enabled);

    const total = items.reduce((sum, item) => sum + toNumber(item.price), 0);
    const millingItem = items.find((item) => item.workType === 'milling' || item.key === 'milling') || null;

    return {
        items,
        total: Math.round((total + Number.EPSILON) * 100) / 100,
        millingPrice: toNumber(millingItem?.price),
        additionalWorksPrice: Math.max(0, total - toNumber(millingItem?.price)),
        enabledCount: items.length,
    };
};

export const getPrimaryWorkOption = (product) => {
    const list = normalizeWorkOptions(product)
        .filter((item) => item.enabled !== false)
        .sort((a, b) => Number(a.sortOrder || 0) - Number(b.sortOrder || 0));

    return list[0] || null;
};

export const hasEnabledWorkOptions = (product) => {
    return Boolean(getPrimaryWorkOption(product));
};

export const getMainPriceText = (product) => {
    const workOption = getPrimaryWorkOption(product);

    if (workOption) {
        const preview = calcMillingPrice(workOption.pricing, workOption.pricing.baseDimensions, workOption.price);

        if (workOption.pricing.enabled && preview.price > 0) {
            return `${workOption.name}: ${fmtMoney(preview.price)} · ${preview.label}`;
        }

        if (workOption.calcMode === 'linearMeter') {
            return `${workOption.name}: ${fmtMoney(workOption.pricePerMeter)} / пог. м`;
        }

        if (workOption.calcMode === 'squareMeter') {
            return `${workOption.name}: ${fmtMoney(workOption.pricePerSquareMeter)} / м²`;
        }

        if (workOption.calcMode === 'cubicMeter') {
            return `${workOption.name}: ${fmtMoney(workOption.pricePerCubicMeter)} / м³`;
        }

        return `${workOption.name}: ${fmtMoney(workOption.price)}`;
    }

    const pricingMode = product?.pricingMode || 'piece';

    if (pricingMode === 'linearMeter') {
        return `${fmtMoney(product?.pricePerMeter)} / пог. м`;
    }

    return fmtMoney(product?.price);
};


const getIndependentVariantProduct = (product = {}) => ({
    ...product,
    price: 0,
    workPrice: 0,
    productPricing: null,
    millingPricing: null,
});

const normalizeVariantProductPricing = ({
    variant,
    materialKey,
    catalog,
    product,
    catalogs,
    isDefault,
}) => {
    const rawPricing = (
        variant?.productPricing
        && typeof variant.productPricing === 'object'
    )
        ? variant.productPricing
        : {};
    const defaultPricing = product?.productPricing || {};
    const hasIndependentConfiguration = (
        toNumber(rawPricing.basePrice) > 0
        || toNumber(rawPricing.manualPrice) > 0
        || toNumber(rawPricing.blankPriceOverride) > 0
        || (Array.isArray(rawPricing.sizeRules) && rawPricing.sizeRules.length > 0)
        || rawPricing.mode === 'manual'
    );
    const inheritAutomaticFormula = !isDefault && !hasIndependentConfiguration;
    const source = {
        ...(inheritAutomaticFormula ? defaultPricing : rawPricing),
        ...rawPricing,
        blankMaterialKey: materialKey,
        blankMaterialName: (
            catalog?.name
            || variant?.materialName
            || rawPricing.blankMaterialName
            || ''
        ),
        materialDensityKgM3: (
            catalog?.densityKgM3
            || rawPricing.materialDensityKgM3
            || 3070
        ),
        materialDensityLabel: (
            catalog?.name
            || rawPricing.materialDensityLabel
            || ''
        ),
    };

    if (inheritAutomaticFormula) {
        source.enabled = defaultPricing.enabled === true;
        source.mode = defaultPricing.mode || 'blankPlusMilling';
        source.baseDimensions = defaultPricing.baseDimensions || source.baseDimensions;
        source.testDimensions = defaultPricing.testDimensions || defaultPricing.previewDimensions || source.testDimensions;
        source.totalMarkupPercent = defaultPricing.totalMarkupPercent ?? source.totalMarkupPercent;
        source.minimumPrice = defaultPricing.minimumPrice ?? source.minimumPrice;
        source.roundTo = defaultPricing.roundTo || source.roundTo;
        source.basePrice = 0;
        source.manualPrice = 0;
        source.blankPriceOverride = 0;
        source.blankType = defaultPricing.blankType || 'stele';
        source.blankPolishingType = defaultPricing.blankPolishingType || 'two-side';
        source.blankSupplierKey = '';
        source.allowEstimatedBlankPrice = true;
        source.blankCatalogRevision = 0;
        source.blankPriceCalculated = 0;
        source.millingPriceCalculated = 0;
        source.subtotalCalculated = 0;
        source.calculatedPrice = 0;
        source.calculationSource = '';
        source.sizeRules = [];
    } else if (!isDefault) {
        if (!hasOwn(rawPricing, 'enabled')) source.enabled = false;
        if (!hasOwn(rawPricing, 'basePrice')) source.basePrice = 0;
        if (!hasOwn(rawPricing, 'manualPrice')) source.manualPrice = 0;
        if (!hasOwn(rawPricing, 'blankPriceOverride')) source.blankPriceOverride = 0;
        if (!Array.isArray(rawPricing.sizeRules)) source.sizeRules = [];
    }

    return normalizeProductPricing(
        source,
        isDefault ? product : getIndependentVariantProduct(product),
        catalogs
    );
};

const normalizeVariantMillingPricing = ({
    variant,
    product,
    isDefault,
}) => {
    const rawPricing = (
        variant?.millingPricing
        && typeof variant.millingPricing === 'object'
    )
        ? variant.millingPricing
        : {};
    const hasIndependentConfiguration = (
        toNumber(rawPricing.basePrice) > 0
        || toNumber(rawPricing.manualPrice) > 0
        || (Array.isArray(rawPricing.sizeRules) && rawPricing.sizeRules.some((rule) => toNumber(rule?.price) > 0))
    );

    // Фрезеровка геометрии не меняется от породы камня. Пока отдельная
    // цена для варианта не задана, используем базовую настройку товара.
    const source = (!isDefault && !hasIndependentConfiguration)
        ? { ...(product?.millingPricing || {}) }
        : (isDefault && !variant?.millingPricing
            ? (product?.millingPricing || {})
            : { ...rawPricing });

    return normalizeMillingPricing(source, product);
};

export const normalizeMaterialPricingVariants = (product = {}, catalogs = []) => {
    const source = Array.isArray(product?.materialPricingVariants)
        ? product.materialPricingVariants
        : [];
    const fallbackKey = slugifyBlankMaterialKey(
        product?.defaultMaterialKey
        || product?.productPricing?.blankMaterialKey
        || inferBlankMaterialKey(product, catalogs)
        || 'gabbro-diabase'
    );
    const seen = new Set();
    const variants = source.map((variant) => {
        const materialKey = slugifyBlankMaterialKey(variant?.materialKey);

        if (!materialKey || seen.has(materialKey)) return null;

        seen.add(materialKey);

        const catalog = getBlankMaterialCatalog(catalogs, materialKey);
        const isDefault = (
            variant?.isDefault === true
            || materialKey === fallbackKey
        );
        const productPricing = normalizeVariantProductPricing({
            variant,
            materialKey,
            catalog,
            product,
            catalogs,
            isDefault,
        });

        return {
            materialKey,
            materialName: String(
                catalog?.name
                || variant?.materialName
                || productPricing.blankMaterialName
                || ''
            ),
            enabled: variant?.enabled !== false,
            isDefault,
            productPricing,
            millingPricing: normalizeVariantMillingPricing({
                variant,
                product,
                isDefault,
            }),
            textureBinding: {
                applyToAll: variant?.textureBinding?.applyToAll !== false,
                materialIndexes: Array.isArray(
                    variant?.textureBinding?.materialIndexes
                )
                    ? [...new Set(
                        variant.textureBinding.materialIndexes.map(
                            (value) => Math.max(
                                0,
                                Math.floor(toNumber(value))
                            )
                        )
                    )]
                    : [],
            },
        };
    }).filter(Boolean);

    if (!variants.length) {
        const catalog = getBlankMaterialCatalog(catalogs, fallbackKey);

        variants.push({
            materialKey: fallbackKey,
            materialName: String(
                catalog?.name
                || product?.productPricing?.blankMaterialName
                || 'Габбро-диабаз'
            ),
            enabled: true,
            isDefault: true,
            productPricing: normalizeProductPricing({
                ...(product?.productPricing || {}),
                blankMaterialKey: fallbackKey,
                blankMaterialName: (
                    catalog?.name
                    || product?.productPricing?.blankMaterialName
                    || ''
                ),
                materialDensityKgM3: (
                    product?.productPricing?.materialDensityKgM3
                    || catalog?.densityKgM3
                    || 3070
                ),
                materialDensityLabel: (
                    product?.productPricing?.materialDensityLabel
                    || catalog?.name
                    || ''
                ),
            }, product, catalogs),
            millingPricing: normalizeMillingPricing(
                product?.millingPricing,
                product
            ),
            textureBinding: {
                applyToAll: true,
                materialIndexes: [],
            },
        });
    }

    if (!variants.some((variant) => variant.isDefault)) {
        variants[0].isDefault = true;
    }

    let defaultFound = false;

    return variants.map((variant) => {
        const isDefault = variant.isDefault && !defaultFound;

        if (isDefault) defaultFound = true;

        return {
            ...variant,
            isDefault,
        };
    });
};

export const serializeMaterialPricingVariants = (
    form = {},
    product = {},
    context = {}
) => {
    const catalogs = context.blankPriceCatalogs || [];
    const variants = normalizeMaterialPricingVariants({
        ...product,
        defaultMaterialKey: form.defaultMaterialKey,
        materialPricingVariants: form.materialPricingVariants,
        productPricing: form.productPricing,
        millingPricing: form.millingPricing,
    }, catalogs);
    const activeKey = slugifyBlankMaterialKey(form.activeMaterialKey);
    const defaultKey = slugifyBlankMaterialKey(form.defaultMaterialKey);
    const canonicalMillingVariant = variants.find((variant) => (
        variant.materialKey === 'gabbro-diabase'
    )) || variants.find((variant) => (
        variant.materialKey === defaultKey || variant.isDefault === true
    )) || variants[0] || null;
    const canonicalMillingKey = canonicalMillingVariant?.materialKey || defaultKey;
    const canonicalRawMillingPricing = activeKey === canonicalMillingKey
        ? form.millingPricing
        : (canonicalMillingVariant?.millingPricing || form.millingPricing);
    const canonicalProductPricingForSizes = normalizeProductPricing(
        form.productPricing,
        product,
        catalogs
    );
    const canonicalMillingPricing = syncWorkPricingToSharedSizes(
        canonicalRawMillingPricing,
        canonicalProductPricingForSizes.sizeRules,
        canonicalProductPricingForSizes.baseDimensions
    );

    return variants.map((variant) => {
        const isActive = variant.materialKey === activeKey;
        const isDefault = (
            variant.materialKey === defaultKey
            || variant.isDefault === true
        );
        const pricingProduct = isDefault
            ? product
            : getIndependentVariantProduct(product);
        const canonicalProductPricing = normalizeProductPricing(form.productPricing, product, catalogs);
        const rawProductPricingSource = isActive
            ? form.productPricing
            : variant.productPricing;
        const productPricingSource = {
            ...rawProductPricingSource,
            baseDimensions: canonicalProductPricing.baseDimensions,
            sizeRules: mergeSharedProductSizeRules(
                rawProductPricingSource?.sizeRules,
                canonicalProductPricing.sizeRules
            ),
        };
        // Фрезеровка хранит одну базовую цену/сетку для всех пород.
        // Материальная разница применяется отдельно через millingMarkupPercent.
        const millingPricingSource = syncWorkPricingToSharedSizes(
            canonicalMillingPricing,
            canonicalProductPricing.sizeRules,
            canonicalProductPricing.baseDimensions
        );
        const catalog = getBlankMaterialCatalog(
            catalogs,
            variant.materialKey
        );
        const productPricing = normalizeProductPricingForSave(
            productPricingSource,
            pricingProduct,
            {
                ...context,
                millingPricing: millingPricingSource,
                millingFallbackPrice: isDefault ? form.workPrice : 0,
                workOptions: context.workOptions || form.workOptions || [],
            }
        );

        return {
            materialKey: variant.materialKey,
            materialName: String(
                catalog?.name
                || variant.materialName
                || productPricing.blankMaterialName
                || ''
            ).trim(),
            enabled: variant.enabled !== false,
            isDefault,
            productPricing,
            millingPricing: normalizeMillingPricingForSave(
                millingPricingSource,
                pricingProduct
            ),
            textureBinding: {
                applyToAll: variant.textureBinding?.applyToAll !== false,
                materialIndexes: Array.isArray(
                    variant.textureBinding?.materialIndexes
                )
                    ? [...new Set(
                        variant.textureBinding.materialIndexes.map(
                            (value) => Math.max(
                                0,
                                Math.floor(toNumber(value))
                            )
                        )
                    )]
                    : [],
            },
        };
    });
};

export const getInitialForm = (product, context = {}) => {
    const catalogs = context.blankPriceCatalogs || [];
    const primaryWork = getPrimaryWorkOption(product) || normalizeWorkOption({}, product, 0);
    const workOptions = normalizeWorkOptions(product);
    const materialPricingVariants = normalizeMaterialPricingVariants(product, catalogs);
    const defaultVariant = materialPricingVariants.find((variant) => variant.isDefault) || materialPricingVariants[0];
    const defaultMaterialKey = defaultVariant?.materialKey || 'gabbro-diabase';

    return {
        workEnabled: !!primaryWork?.enabled,
        workKey: primaryWork?.key || 'milling',
        workName: primaryWork?.name || 'Фрезеровка',
        workType: primaryWork?.workType || 'milling',
        workCalcMode: primaryWork?.calcMode || product?.workCalcMode || 'fixed',
        workPrice: primaryWork?.price ?? product?.workPrice ?? '',
        workPricePerMeter: primaryWork?.pricePerMeter ?? product?.workPricePerMeter ?? '',
        workPricePerSquareMeter: primaryWork?.pricePerSquareMeter ?? product?.workPricePerSquareMeter ?? '',
        workPricePerCubicMeter: primaryWork?.pricePerCubicMeter ?? product?.workPricePerCubicMeter ?? '',
        workNote: primaryWork?.note || '',
        millingPricing: primaryWork?.pricing || product?.millingPricing || defaultVariant?.millingPricing || normalizeMillingPricing({}, product),
        productPricing: defaultVariant?.productPricing || normalizeProductPricing(product?.productPricing, product, catalogs),
        defaultMaterialKey,
        activeMaterialKey: defaultMaterialKey,
        materialPricingVariants,
        materialSelectionMode: normalizeMaterialSelectionMode(
            product?.materialSelectionMode,
            product?.categoryName
        ),
        surfaceFinishPolicy: normalizeSurfaceFinishPolicy(product?.surfaceFinishPolicy),
        workOptions,
        hashtags: tagsToString(product?.hashtags),
        modelPartsEnabled: product?.modelPartsEnabled === true,
    };
};

const serializeWorkOptionForSave = (value, product, index = 0) => {
    const normalized = normalizeWorkOption(value, product, index);

    return {
        key: normalized.key,
        name: normalized.name,
        enabled: normalized.enabled !== false,
        workType: normalized.workType,
        calcMode: normalized.calcMode,
        price: normalized.calcMode === 'fixed' ? toNumber(normalized.price) : 0,
        pricePerMeter: normalized.calcMode === 'linearMeter' ? toNumber(normalized.pricePerMeter) : 0,
        pricePerSquareMeter: normalized.calcMode === 'squareMeter' ? toNumber(normalized.pricePerSquareMeter) : 0,
        pricePerCubicMeter: normalized.calcMode === 'cubicMeter' ? toNumber(normalized.pricePerCubicMeter) : 0,
        pricing: {
            ...normalizeMillingPricingForSave(normalized.pricing, product),
            enabled: normalized.enabled !== false && normalized.pricing?.enabled === true,
        },
        sortOrder: toNumber(normalized.sortOrder ?? index),
        note: String(normalized.note || ''),
    };
};

export const buildPayload = (form, product, context = {}) => {
    const workCalcMode = form.workCalcMode || 'fixed';
    const workType = form.workType || 'milling';
    const workName = String(form.workName || getDefaultWorkName(workType)).trim() || getDefaultWorkName(workType);
    const workEnabled = form.workEnabled === true;
    const currentWorkKey = String(form.workKey || getWorkKey(workType, 0));
    const normalizedPricing = normalizeMillingPricingForSave(
        syncWorkPricingToSharedSizes(
            form.millingPricing,
            form?.productPricing?.sizeRules || [],
            form?.productPricing?.baseDimensions || null
        ),
        product
    );
    const sourceWorkOptions = Array.isArray(form.workOptions) && form.workOptions.length
        ? form.workOptions
        : normalizeWorkOptions(product);
    const existingCurrentIndex = sourceWorkOptions.findIndex((item, index) => {
        const normalized = normalizeWorkOption(item, product, index);
        return String(normalized.key) === currentWorkKey;
    });
    const existingCurrent = existingCurrentIndex >= 0
        ? normalizeWorkOption(sourceWorkOptions[existingCurrentIndex], product, existingCurrentIndex)
        : null;

    const currentWorkOption = {
        key: currentWorkKey,
        name: workName,
        enabled: workEnabled,
        workType,
        calcMode: workCalcMode,
        price: workEnabled && workCalcMode === 'fixed' ? toNumber(form.workPrice) : 0,
        pricePerMeter: workEnabled && workCalcMode === 'linearMeter' ? toNumber(form.workPricePerMeter) : 0,
        pricePerSquareMeter: workEnabled && workCalcMode === 'squareMeter' ? toNumber(form.workPricePerSquareMeter) : 0,
        pricePerCubicMeter: workEnabled && workCalcMode === 'cubicMeter' ? toNumber(form.workPricePerCubicMeter) : 0,
        pricing: {
            ...normalizedPricing,
            enabled: workEnabled && normalizedPricing.enabled === true,
        },
        sortOrder: toNumber(existingCurrent?.sortOrder ?? 0),
        note: String(form.workNote ?? existingCurrent?.note ?? ''),
    };

    let currentWasMerged = false;
    const mergedWorkOptions = sourceWorkOptions.map((item, index) => {
        const normalized = normalizeWorkOption(item, product, index);

        if (String(normalized.key) === currentWorkKey) {
            currentWasMerged = true;
            return currentWorkOption;
        }

        const syncedPricing = syncWorkPricingToSharedSizes(
            normalized.pricing,
            form?.productPricing?.sizeRules || [],
            form?.productPricing?.baseDimensions || null
        );

        return serializeWorkOptionForSave({
            ...normalized,
            pricing: syncedPricing,
        }, product, index);
    });

    if (!currentWasMerged) mergedWorkOptions.push(currentWorkOption);

    const normalizedProductPricing = normalizeProductPricingForSave(form.productPricing, product, {
        ...context,
        millingPricing: normalizedPricing,
        millingFallbackPrice: form.workPrice,
        workOptions: mergedWorkOptions,
    });
    const enabledWorkOptions = mergedWorkOptions
        .filter((item) => item.enabled !== false)
        .sort((a, b) => Number(a.sortOrder || 0) - Number(b.sortOrder || 0));
    const primaryWorkOption = enabledWorkOptions[0] || null;
    const legacyWorkOption = primaryWorkOption || currentWorkOption;
    const hasEnabledWork = Boolean(primaryWorkOption);
    const hasProductPrice =
        normalizedProductPricing.enabled === true
        || toNumber(normalizedProductPricing.basePrice) > 0
        || toNumber(product?.pricePerMeter) > 0;
    const materialPricingVariants = serializeMaterialPricingVariants(form, product, {
        ...context,
        workOptions: mergedWorkOptions,
    });
    const defaultMaterialKey = slugifyBlankMaterialKey(
        form.defaultMaterialKey
        || materialPricingVariants.find((variant) => variant.isDefault)?.materialKey
        || 'gabbro-diabase'
    );
    const defaultVariant = materialPricingVariants.find((variant) => variant.materialKey === defaultMaterialKey)
        || materialPricingVariants.find((variant) => variant.isDefault)
        || materialPricingVariants[0];
    const rootProductPricing = defaultVariant?.productPricing || normalizedProductPricing;
    const rootMillingPricing = defaultVariant?.millingPricing || legacyWorkOption.pricing;
    const rootWorkOptions = mergedWorkOptions.map((item) => {
        const isMilling = item.workType === 'milling' || item.key === 'milling';
        if (!isMilling) return item;

        return {
            ...item,
            price: toNumber(rootMillingPricing.basePrice) || item.price,
            pricing: rootMillingPricing,
        };
    });

    return {
        pricingMode: hasEnabledWork
            ? (hasProductPrice ? 'mixed' : 'service')
            : (product?.pricingMode === 'linearMeter' ? 'linearMeter' : 'piece'),
        // Старое поле price оставляем как техническую базу для совместимости.
        price: rootProductPricing.basePrice || toNumber(product?.price),
        productPricing: rootProductPricing,
        defaultMaterialKey,
        materialPricingVariants,
        materialSelectionMode: normalizeMaterialSelectionMode(
            form.materialSelectionMode,
            product?.categoryName
        ),
        surfaceFinishPolicy: normalizeSurfaceFinishPolicy(form.surfaceFinishPolicy),
        workType: hasEnabledWork ? legacyWorkOption.workType : 'none',
        workLabel: hasEnabledWork ? legacyWorkOption.name : '',
        workCalcMode: legacyWorkOption.calcMode,
        workPrice: hasEnabledWork
            ? ((legacyWorkOption.workType === 'milling' || legacyWorkOption.key === 'milling')
                ? (toNumber(rootMillingPricing.basePrice) || legacyWorkOption.price)
                : legacyWorkOption.price)
            : 0,
        workPricePerMeter: hasEnabledWork ? legacyWorkOption.pricePerMeter : 0,
        workPricePerSquareMeter: hasEnabledWork ? legacyWorkOption.pricePerSquareMeter : 0,
        workPricePerCubicMeter: hasEnabledWork ? legacyWorkOption.pricePerCubicMeter : 0,
        millingPricing: rootMillingPricing,
        workOptions: rootWorkOptions,
        hashtags: normalizeTags(form.hashtags),
        modelPartsEnabled: form.modelPartsEnabled === true,
    };
};

const isCompletePositiveDimensions = (dimensions) => (
    toNumber(dimensions?.height) > 0 &&
    toNumber(dimensions?.width) > 0 &&
    toNumber(dimensions?.thickness) > 0
);

const getDimensionsSignature = (dimensions) => (
    [
        Math.round(toNumber(dimensions?.height) * 1000) / 1000,
        Math.round(toNumber(dimensions?.width) * 1000) / 1000,
        Math.round(toNumber(dimensions?.thickness) * 1000) / 1000,
    ].join('x')
);

const getEnabledRulesCount = (rules) => (
    (Array.isArray(rules) ? rules : []).filter((rule) => rule?.enabled !== false).length
);

export const getProductPricingCardSummary = (product) => {
    const productPricing = normalizeProductPricing(product?.productPricing, product);
    const workOptions = normalizeWorkOptions(product).filter((item) => item.enabled !== false);
    const baseRule = productPricing.sizeRules.find((rule) => sameSharedDimensions(rule, productPricing.baseDimensions))
        || productPricing.sizeRules.find((rule) => rule.isBase === true)
        || null;
    const subscriberPrice = toNumber(
        baseRule?.subscriberPrice
        || productPricing.subscriberPriceCalculated
    );
    const publicPrice = toNumber(
        baseRule?.publicPrice
        || productPricing.publicPriceCalculated
    );
    const productBaseReady =
        productPricing.enabled === true &&
        isCompletePositiveDimensions(productPricing.baseDimensions) &&
        (
            publicPrice > 0
            || subscriberPrice > 0
            || toNumber(productPricing.basePrice) > 0
        );
    const workItems = workOptions.map((work, index) => {
        const pricing = syncWorkPricingToSharedSizes(
            work.pricing,
            productPricing.sizeRules,
            productPricing.baseDimensions
        );
        const preview = calcWorkOptionPrice(
            { ...work, pricing },
            productPricing.baseDimensions
        );

        return {
            key: work.key || `${work.workType}-${index}`,
            name: work.name || getDefaultWorkName(work.workType),
            workType: work.workType,
            price: toNumber(preview.price),
            configured: toNumber(preview.price) > 0,
        };
    });
    const worksTotal = workItems.reduce((sum, item) => sum + item.price, 0);

    return {
        complete: productBaseReady,
        dimensions: productPricing.baseDimensions,
        dimensionsText: isCompletePositiveDimensions(productPricing.baseDimensions)
            ? formatMillingDimensions(productPricing.baseDimensions)
            : 'Размер не указан',
        subscriberPrice,
        publicPrice,
        subscriberPriceText: subscriberPrice > 0 ? fmtMoney(subscriberPrice) : 'Не рассчитана',
        publicPriceText: publicPrice > 0 ? fmtMoney(publicPrice) : 'Не рассчитана',
        rulesCount: getEnabledRulesCount(productPricing.sizeRules),
        worksTotal,
        worksTotalText: worksTotal > 0 ? fmtMoney(worksTotal) : 'Без работ',
        worksCount: workItems.length,
        workItems,
        product: {
            title: 'Изделие',
            configured: productBaseReady,
            formulaEnabled: productPricing.enabled === true,
            price: publicPrice || subscriberPrice || toNumber(productPricing.basePrice),
            priceText: publicPrice > 0 ? fmtMoney(publicPrice) : (subscriberPrice > 0 ? fmtMoney(subscriberPrice) : fmtMoney(productPricing.basePrice)),
            dimensions: productPricing.baseDimensions,
            dimensionsText: formatMillingDimensions(productPricing.baseDimensions),
            rulesCount: getEnabledRulesCount(productPricing.sizeRules),
            statusText: productBaseReady ? 'База настроена' : 'Указать цену и размер',
        },
        work: {
            title: workItems.length === 1 ? workItems[0].name : 'Работы',
            configured: workItems.length === 0 || workItems.every((item) => item.configured),
            enabled: workItems.length > 0,
            formulaEnabled: workItems.some((item) => item.configured),
            price: worksTotal,
            priceText: worksTotal > 0 ? fmtMoney(worksTotal) : 'Без работ',
            dimensions: productPricing.baseDimensions,
            dimensionsText: formatMillingDimensions(productPricing.baseDimensions),
            rulesCount: workItems.length,
            statusText: workItems.length ? `${workItems.length} работ(ы)` : 'Работы не нужны',
        },
    };
};

const appendRulesValidationErrors = (errors, rules, label, { checkManualWeight = false } = {}) => {
    const seen = new Map();

    (Array.isArray(rules) ? rules : []).forEach((rule, index) => {
        const number = index + 1;

        if (rule?.enabled === false) return;

        if (!isCompletePositiveDimensions(rule)) {
            errors.push(`${label}: в размере №${number} заполни высоту, ширину и толщину.`);
            return;
        }

        if (checkManualWeight && rule?.weightManual === true && toNumber(rule.weightKg) <= 0) {
            errors.push(`${label}: в размере №${number} указан ручной вес, но поле веса пустое.`);
        }

        const signature = getDimensionsSignature(rule);

        if (seen.has(signature)) {
            errors.push(`${label}: активные размеры №${seen.get(signature)} и №${number} полностью совпадают.`);
            return;
        }

        seen.set(signature, number);
    });
};

export const validateAdminProduct3DForm = (form, product, context = {}) => {
    const errors = [];
    const productPricing = normalizeProductPricing(
        form?.productPricing,
        product,
        context.blankPriceCatalogs || []
    );
    const millingPricing = normalizeMillingPricing(
        form?.millingPricing,
        product,
        context.pricingPolicy || {}
    );

    if (productPricing.enabled) {
        if (!isCompletePositiveDimensions(productPricing.baseDimensions)) {
            errors.push('Изделие: базовый размер должен содержать высоту, ширину и толщину больше нуля.');
        }

        if (productPricing.mode === 'manual') {
            if (toNumber(productPricing.manualPrice) <= 0) {
                errors.push('Изделие: укажи ручную итоговую цену больше нуля.');
            }
        } else if (productPricing.mode === 'blankPlusMilling') {
            const preview = calcProductPrice(
                productPricing,
                productPricing.baseDimensions,
                product?.price,
                {
                    blankPriceCatalogs: context.blankPriceCatalogs || [],
                    millingPricing: form?.millingPricing,
                    millingFallbackPrice: form?.workPrice,
                    pricingPolicy: context.pricingPolicy || {},
                }
            );

            if (!productPricing.blankMaterialKey) {
                errors.push('Изделие: выбери материал заготовки.');
            }
            if (
                productPricing.blankSizingMode === 'manual'
                && !isCompletePositiveDimensions(form?.productPricing?.manualBlankDimensions)
            ) {
                errors.push('Изделие: в ручном размере заготовки заполни высоту, ширину и толщину.');
            }
            if (toNumber(preview.blankPrice) <= 0) {
                errors.push(`Изделие: ${preview.blankSourceLabel || 'не указана цена заготовки'}.`);
            }
            if (toNumber(preview.price) <= 0) {
                errors.push('Изделие: итоговая цена по автоматической формуле не рассчитана.');
            }
        } else if (toNumber(productPricing.basePrice) <= 0) {
            errors.push('Изделие: укажи базовую цену больше нуля.');
        }

        if (toNumber(productPricing.materialDensityKgM3) <= 0) {
            errors.push('Изделие: укажи плотность камня больше нуля.');
        }
    }

    if (productPricing.enabled) {
        appendRulesValidationErrors(
            errors,
            productPricing.sizeRules,
            'Размеры изделия',
            { checkManualWeight: true }
        );
    }

    if (form?.workEnabled === true) {
        const workName = String(form?.workName || getDefaultWorkName(form?.workType)).trim() || 'Работа';
        const currentWork = normalizeWorkOption({
            key: form?.workKey,
            name: workName,
            enabled: true,
            workType: form?.workType,
            calcMode: form?.workCalcMode,
            price: form?.workPrice,
            pricePerMeter: form?.workPricePerMeter,
            pricePerSquareMeter: form?.workPricePerSquareMeter,
            pricePerCubicMeter: form?.workPricePerCubicMeter,
            pricing: millingPricing,
        }, product);
        const preview = calcWorkOptionPrice(currentWork, productPricing.baseDimensions, context.pricingPolicy || {});

        if (toNumber(preview.price) <= 0) {
            errors.push(`${workName}: укажи цену работы больше нуля либо цену для общего размера.`);
        }

        if (millingPricing.enabled && !isCompletePositiveDimensions(productPricing.baseDimensions)) {
            errors.push(`${workName}: общий базовый размер должен содержать высоту, ширину и толщину больше нуля.`);
        }
    }

    return errors;
};

export const isSamePayload = (a, b, product, context = {}) => {
    return JSON.stringify(buildPayload(a, product, context)) === JSON.stringify(buildPayload(b, product, context));
};

export const getViewerTheme = (mode) => {
    if (mode === 'dark') {
        return {
            background: '#050a14',
            fog: '#050a14',
            hemiGround: '#111827',
            ambient: 0.95,
            mainLight: 2.2,
            fillLight: 0.9,
            shadow: 0.35,
        };
    }

    if (mode === 'studio') {
        return {
            background: '#0b1220',
            fog: '#0b1220',
            hemiGround: '#1f2937',
            ambient: 1.15,
            mainLight: 2.55,
            fillLight: 1.05,
            shadow: 0.42,
        };
    }

    return {
        background: '#eef2f7',
        fog: '#eef2f7',
        hemiGround: '#cbd5e1',
        ambient: 1.35,
        mainLight: 2.8,
        fillLight: 1.2,
        shadow: 0.22,
    };
};

export const applyTextureSettings = (texture) => {
    if (!texture?.isTexture) return;

    texture.colorSpace = THREE.SRGBColorSpace;
    texture.needsUpdate = true;
};

export const createFallbackMaterial = () => {
    return new THREE.MeshStandardMaterial({
        color: '#151515',
        metalness: 0,
        roughness: 0.42,
        side: THREE.DoubleSide,
    });
};

export const normalizeMaterials = (materials) => {
    const textureKeys = [
        'map',
        'emissiveMap',
        'aoMap',
        'normalMap',
        'roughnessMap',
        'metalnessMap',
        'alphaMap',
        'bumpMap',
        'displacementMap',
        'lightMap',
        'envMap',
    ];

    const prepare = (material) => {
        if (!material?.clone) {
            return createFallbackMaterial();
        }

        const cloned = material.clone();

        // Material.clone() сохраняет ссылки на Texture. Для независимого
        // viewport клонируем карты отдельно, иначе замена/очистка текстуры
        // в админке испортит материал, сохранённый в общем Redux-кеше модели.
        textureKeys.forEach((key) => {
            const texture = material[key];
            if (!texture?.isTexture || !texture.clone) return;
            cloned[key] = texture.clone();
            cloned[key].image = texture.image;
            applyTextureSettings(cloned[key]);
        });

        cloned.side = THREE.DoubleSide;
        cloned.metalness = typeof cloned.metalness === 'number' ? cloned.metalness : 0;
        cloned.roughness = typeof cloned.roughness === 'number' ? cloned.roughness : 0.55;
        cloned.needsUpdate = true;

        return cloned;
    };

    if (Array.isArray(materials) && materials.length) {
        return materials.map((material) => prepare(material));
    }

    if (materials?.clone) {
        return prepare(materials);
    }

    return createFallbackMaterial();
};
